import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import "./Onboard.css";
import axios from "axios";

import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import X from "../../assets/img/x.png";
import ImagePlaceholder from "../../assets/img/img_placeholder.png";
import { Accordion } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { updateAadhaarImageBack } from "../../store/actions/HrmsOnboard";
import Constant from "../../utils/constant";

export default function Onboard() {
  // const [file, setFile] = useState(null);
  // const [uploading, setUploading] = useState(false);
  const dispatch = useDispatch();
  // const { loading, data, error } = useSelector((state) => state.image);
  const [workLocations, setWorkLocations] = useState([]);
  const [filteredWorkLocations, setFilteredWorkLocations] = useState([]);
  const [showWorkLocationDropdown, setShowWorkLocationDropdown] =
    useState(false);

  const [photoFile, setPhotoFile] = useState({});
  const [errors, setErrors] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [manager, setManager] = useState([]);
  const [department, setdepartment] = useState([]);
  const [role, setRoles] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [pincodes, setPincodes] = useState([]);
  const [permanentCities, setPermanentCities] = useState([]);
  const [permanentPincodes, setPermanentPincodes] = useState([]);
  // State to manage the checked status of each document
  const [checkedItems, setCheckedItems] = useState(new Array(11).fill(false));
  // fetch reporting Manager
  useEffect(() => {
    const fetchManagers = async () => {
      try {
        const response = await axios.get(
          `${Constant.BASE_URL}hrms/listManager`
        );
        setManager(response.data.data);
      } catch (error) {
        console.error("Error fetching managers:", error);
      }
    };

    fetchManagers();
  }, []);
  useEffect(() => {
    const fetchDepartment = async () => {
      try {
        const response = await axios.post(
          Constant.BASE_URL + "hrms/listDepartment?page&limit"
        );
        setdepartment(response.data.data);
      } catch (error) {
        console.error("Error fetching List:", error);
      }
    };
    fetchDepartment();
  }, []);
  useEffect(() => {
    const fetchroles = async () => {
      try {
        const response = await axios.post(
          Constant.BASE_URL + "hrms/listRoles?page&limit"
        );
        setRoles(response.data.data);
      } catch (error) {
        console.error("Error fetching List:", error);
      }
    };
    fetchroles();
  }, []);

  useEffect(() => {
    const fetchWorkLocations = async () => {
      try {
        const response = await axios.get(
          "https://api.policicue.com/hrms/listStates"
        );
        if (response.data && response.data.data) {
          const locationNames = response.data.data.map((loc) => loc.state);
          setWorkLocations(locationNames);
          setFilteredWorkLocations(locationNames);
        }
      } catch (error) {
        console.error("Error fetching work locations:", error);
      }
    };
    fetchWorkLocations();
  }, []);

  const [companyData, setCompanyData] = useState([
    {
      company_name: "",
      job_title: "",
      start_date: "",
      end_date: "",
      pay_slip: null,
      relieving_letter: null,
      signed_resignation_letter: null,
      offer_letter: null,
    },
  ]);
  const addJobSection = () => {
    const newCompany = {
      company_name: "",
      job_title: "",
      start_date: "",
      end_date: "",
      pay_slip: null,
      relieving_letter: null,
      signed_resignation_letter: null,
      offer_letter: null,
    };
    setCompanyData([...companyData, newCompany]);
  };
  const uploadDocument = async (file) => {
    try {
      const formData = new FormData();
      formData.append("documentData", file);

      const response = await fetch(
        // "https://uatapi.policicue.com/hrms/addDocuments",
        Constant.BASE_URL + `hrms/addDocuments`,
        {
          method: "POST",
          body: formData,
        }
      );

      const result = await response.json();

      if (result.status === 1) {
        return {
          photoURL: result.photoURL,
          key: result.key,
        };
      } else {
        console.error("Upload failed:", result.message);
        return null;
      }
    } catch (error) {
      console.error("Error uploading document:", error);
      return null;
    }
  };
  const handleInputChangeCompany = async (e, type, index) => {
    const { name, value, files } = e.target;
    const updatedData = [...companyData];

    // Define the max size in bytes (1MB)
    const MAX_FILE_SIZE = 1 * 1024 * 1024;

    if (files && files[0]) {
      const file = files[0];

      // START: File Size Validation
      if (file.size > MAX_FILE_SIZE) {
        alert(
          "File is too large! Please upload a file smaller than 1MB or compress the existing one."
        );
        e.target.value = null; // Clear the file input
        return; // Stop the function from proceeding
      }
      // END: File Size Validation

      if (!file.type.startsWith("image/") && !file.type.includes("pdf")) {
        alert("Please upload a valid image or PDF file.");
        return;
      }

      setPhotoLoad(true);

      try {
        const formData = new FormData();
        formData.append("documentData", file);

        const response = await fetch(Constant.BASE_URL + `hrms/addDocuments`, {
          method: "POST",
          body: formData,
        });

        const result = await response.json();

        if (result.status === 1) {
          const uploadedURL = result.photoURL;
          updatedData[index][name] = uploadedURL;
          setCompanyData(updatedData);
          console.log(`${name} uploaded successfully:`, uploadedURL);
        } else {
          console.error("Upload failed:", result.message);
          alert("File upload failed.");
        }
      } catch (error) {
        console.error("Error uploading file:", error);
        alert("Something went wrong while uploading. Try again.");
      }

      setPhotoLoad(false);
    } else {
      // Handle text field inputs like company_name, job_title, etc.
      updatedData[index][name] = value;
      setCompanyData(updatedData);
    }

    console.log("After update, companyData:", updatedData);
  };
  useEffect(() => {
    const fetchStates = async () => {
      try {
        const response = await axios.get(
          `${Constant.BASE_URL}hrms/listStates`
          // `http://localhost:1051/hrms/listStates`
        );
        if (response.data.status === 1) {
          setStates(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching states:", error);
      }
    };
    fetchStates();
  }, []);

  // Fetch cities when a state is selected for residential address
  // Fetch cities when a state is selected for residential address
  const handleStateChange = async (e) => {
    const stateName = e.target.value;
    handleInputChange(e, "employee");
    setCities([]); // Clear previous cities
    setPincodes([]);
    setEmployeeData((prev) => ({ ...prev, city: "", pincode: "" }));

    if (stateName) {
      try {
        // ✅ CORRECTED URL
        const response = await axios.post(
          // `http://localhost:1051/hrms/listCities`,
          `${Constant.BASE_URL}hrms/listCities`,

          { stateName }
        );
        if (response.data.status === 1) {
          setCities(response.data.data);
        }
      } catch (error) {
        // If no cities are found, the API might return a 404, which Axios treats as an error.
        console.error("Error fetching cities:", error);
        setCities([]); // Ensure cities array is empty on error
      }
    }
  };

  // Fetch cities when a state is selected for permanent address
  const handlePermanentStateChange = async (e) => {
    const stateName = e.target.value;
    handleInputChange(e, "employee");
    setPermanentCities([]); // Clear previous cities
    setPermanentPincodes([]);
    setEmployeeData((prev) => ({ ...prev, pa_city: "", pa_pincode: "" }));

    if (stateName) {
      try {
        // ✅ CORRECTED URL
        const response = await axios.post(
          // `http://localhost:1051/hrms/listCities`,
          `${Constant.BASE_URL}hrms/listCities`,

          { stateName }
        );
        if (response.data.status === 1) {
          setPermanentCities(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching permanent cities:", error);
        setPermanentCities([]); // Ensure cities array is empty on error
      }
    }
  };

  // Fetch pincodes when a city is selected for residential address
  // Fetch pincodes when a city is selected for residential address
  const handleCityChange = async (e) => {
    const cityName = e.target.value;
    handleInputChange(e, "employee");
    setPincodes([]);
    setEmployeeData((prev) => ({ ...prev, pincode: "" }));

    if (cityName) {
      try {
        // ✅ CORRECTED URL
        const response = await axios.post(
          // `http://localhost:1051/hrms/listPincode`,

          `${Constant.BASE_URL}hrms/listPincode`,

          { cityName }
        );
        if (response.data.status === 1) {
          setPincodes(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching pincodes:", error);
        setPincodes([]); // Clear pincodes on error
      }
    }
  };

  // Fetch pincodes when a city is selected for permanent address
  const handlePermanentCityChange = async (e) => {
    const cityName = e.target.value;
    handleInputChange(e, "employee");
    setPermanentPincodes([]);
    setEmployeeData((prev) => ({ ...prev, pa_pincode: "" }));

    if (cityName) {
      try {
        // ✅ CORRECTED URL
        const response = await axios.post(
          // `http://localhost:1051/hrms/listPincode`,

          `${Constant.BASE_URL}hrms/listPincode`,

          { cityName }
        );
        if (response.data.status === 1) {
          setPermanentPincodes(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching permanent pincodes:", error);
        setPermanentPincodes([]); // Clear pincodes on error
      }
    }
  };

  const handleCheckboxChangee = (index) => {
    const updatedCheckedItems = [...checkedItems];
    updatedCheckedItems[index] = !updatedCheckedItems[index];
    setCheckedItems(updatedCheckedItems);
  };

  const [isDisabled, setIsDisabled] = useState(false);
  const [photoLoad, setPhotoLoad] = useState(false);
  const [employeeData, setEmployeeData] = useState({
    employee_id: "",
    policicue_offer_letter: "",
    profile_pic: "",
    resume: "",
    title: "Mr",
    first_name: "",
    last_name: "",
    email: "",
    joining_position: " ",
    department: "",
    joining_date: "",
    reporting_manager: "",
    work_location: "",
    employee_type: "",
    shift_timing: "",
    contact_number: "",
    residential_address: "",
    city: "",
    state: "",
    pincode: "",
    country: "",
    landmark: "",
    permanent_address: "",
    pa_city: "",
    pa_state: "",
    pa_pincode: "",
    pa_country: "",
    pa_landmark: "",
    reference1: "",
    reference2: "",
    inhand_salary: "",
    basic_salary: "",
    conveyance: "",

    provident_fund: "",
    special_allowance: "",
    // hra: "",
    emergency_contact_number: "",
    dob: "",
    gender: "",
    marital_status: "",
    highest_qualification: "",
    dgree: "",
    degree_upload: "",
    blood_group: "",
    institute_university_name: "",
    year_of_graduation: "2000",
    board_of_education: " ",
    calss_10_percentage: "",
    class_12_percentage: "",
    class_12_stream: "",
    class_10_marksheet: "",
    class_12_marksheet: "",
    highest_qualification_marksheet: "",
    adhar: "",
    pan: "",
    passport: "",
    bank_name: "",
    bank_account_number: "",
    account_holder_name: "",
    ifsc_code: "",
    bank_document_type: "",
    bank_document_upload: "",
    skill_acquired: "",
    additional_courses: "",
    certification_skill_acquired: "",
    certification_additional_courses: "",
  });
  const [chequePhoto, setChequePhoto] = useState(null);

  const [workingCompany, setWorkingCompany] = useState([
    {
      company_name: "",
      job_title: " ",
      start_date: "",
      end_date: "",
      pay_slip: "",
      relieving_letter: "",
      signed_resignation_letter: "",
      offer_letter: "",
    },
  ]);

  const removeJobSection = (index) => {
    if (workingCompany.length > 1) {
      setWorkingCompany((prevCompanies) =>
        prevCompanies.filter((_, i) => i !== index)
      );
    }
  };

  const [familyDetail, setFamilyDetail] = useState([
    {
      member_name: "",
      relation: "",
      member_dob: "",
      occupation: "",
      member_contact_number: "",
    },
  ]);

  const AddFamilyMember = () => {
    setFamilyDetail((prev) => [
      ...prev,
      {
        member_name: "",
        relation: "",
        member_dob: "",
        occupation: "",
        member_contact_number: "",
      },
    ]);
  };

  const deleteFamily = (index) => {
    if (familyDetail.length > 1) {
      setFamilyDetail((prev) => prev.filter((_, i) => i !== index));
    }
  };
  const deleteCompany = (index) => {
    if (familyDetail.length > 1) {
      setFamilyDetail((prev) => prev.filter((_, i) => i !== index));
    }
  };

  const [class10Details, setClass10Details] = useState({
    board_of_education: "",
    class_10_percentage: "",
    class_10_marksheet: null,
  });

  const [class12Details, setClass12Details] = useState({
    class_12_percentage: "",
    class_12_stream: "",
    class_12_marksheet: null,
  });

  // const handleInputChange = async (e, section, index = null) => {
  //   const { name, files, value } = e.target;

  //   if (section === "class10") {
  //     setClass10Details((prev) => ({
  //       ...prev,
  //       [name]: files && files[0] ? files[0] : value,
  //     }));
  //   } else if (section === "class12") {
  //     setClass12Details((prev) => ({
  //       ...prev,
  //       [name]: files && files[0] ? files[0] : value,
  //     }));
  //   } else if (section === "qualification") {
  //     // Future logic for qualification section
  //   }

  //   // Handle file input
  //   if (files && files[0]) {
  //     const file = files[0];

  //     // Validate file
  //     if (!file.type.startsWith("image/")) {
  //       setErrors((prev) => ({
  //         ...prev,
  //         [`${name}File`]: "Please upload a valid image file.",
  //       }));
  //       return;
  //     }

  //     // Generate preview
  //     const reader = new FileReader();
  //     reader.onloadend = () => {
  //       if (section === "cheque") {
  //         setChequePhoto(reader.result);
  //       } else {
  //         setPhotoFile((prevFiles) => ({
  //           ...prevFiles,
  //           [name]: reader.result,
  //         }));
  //       }
  //       setErrors((prev) => ({
  //         ...prev,
  //         [`${name}File`]: "",
  //       }));
  //     };
  //     reader.readAsDataURL(file);

  //     // Upload to API
  //     const formData = new FormData();
  //     formData.append("documentData", file);

  //     try {
  //       const response = await axios.post(
  //         `${Constant.BASE_URL}hrms/addDocuments`,
  //         formData,
  //         {
  //           headers: {
  //             "Content-Type": "multipart/form-data",
  //           },
  //         }
  //       );

  //       const fileUrl = response.data.photoURL;
  //       console.log("Uploaded file URL:", fileUrl);

  //       if (section === "cheque") {
  //         setChequePhoto(fileUrl);
  //       } else if (section === "employee") {
  //         setEmployeeData((prevData) => ({
  //           ...prevData,
  //           [name]: fileUrl,
  //         }));
  //       } else if (section === "job" && index !== null) {
  //         const updatedCompanies = [...companyData];
  //         updatedCompanies[index][name] = fileUrl;
  //         setCompanyData(updatedCompanies);
  //       }
  //     } catch (error) {
  //       console.error("Error uploading file:", error);
  //       alert("Failed to upload file. Please try again.");
  //     }
  //   } else {
  //     // Handle non-file input
  //     if (section === "cheque") {
  //       setChequePhoto(null);
  //     } else if (section === "employee") {
  //       if (name === "department") {
  //         setEmployeeData((prevData) => ({
  //           ...prevData,
  //           department: value,
  //         }));
  //       } else if (name === "manager") {
  //         setEmployeeData((prevData) => ({
  //           ...prevData,
  //           reporting_manager: value,
  //         }));
  //       } else {
  //         setEmployeeData((prevData) => ({
  //           ...prevData,
  //           [name]: value,
  //         }));
  //       }
  //     } else if (section === "job" && index !== null) {
  //       const updatedCompanies = [...companyData];
  //       updatedCompanies[index][name] = value;
  //       setCompanyData(updatedCompanies);
  //     } else if (section === "Family" && index !== null) {
  //       const updatedFamily = [...familyDetail];
  //       updatedFamily[index][name] = value;
  //       setFamilyDetail(updatedFamily);
  //     }
  //   }
  // };
  const removeCompanySection = (index) => {
    if (companyData.length > 1) {
      setCompanyData((prevCompanies) =>
        prevCompanies.filter((_, i) => i !== index)
      );
    }
  };
  const handleInputChange = async (e, section, index = null) => {
    const { name, files, value } = e.target;

    // Define the max size in bytes (1MB)
    const MAX_FILE_SIZE = 1 * 1024 * 1024;

    if (section === "class10") {
      setClass10Details((prev) => ({
        ...prev,
        [name]: files && files[0] ? files[0] : value,
      }));
    } else if (section === "class12") {
      setClass12Details((prev) => ({
        ...prev,
        [name]: files && files[0] ? files[0] : value,
      }));
    } else if (section === "qualification") {
      // Future logic for qualification section
    }

    // Handle file input
    if (files && files[0]) {
      const file = files[0];

      // START: File Size Validation
      if (file.size > MAX_FILE_SIZE) {
        alert(
          "File is too large! Please upload a file smaller than 1MB or compress the existing one."
        );
        e.target.value = null; // Clear the file input
        return; // Stop the function from proceeding
      }
      // END: File Size Validation

      const allowedTypes = [
        "image/png",
        "image/jpeg",
        "image/jpg",
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      ];

      if (!allowedTypes.includes(file.type)) {
        setErrors((prev) => ({
          ...prev,
          [`${name}File`]: "Please upload jpg, png, pdf, doc, or docx file.",
        }));
        return;
      }

      if (file.type.startsWith("image/")) {
        const reader = new FileReader();
        reader.onloadend = () => {
          if (section === "cheque") {
            setChequePhoto(reader.result);
          } else {
            setPhotoFile((prevFiles) => ({
              ...prevFiles,
              [name]: reader.result,
            }));
          }
          setErrors((prev) => ({
            ...prev,
            [`${name}File`]: "",
          }));
        };
        reader.readAsDataURL(file);
      } else {
        setPhotoFile((prevFiles) => ({
          ...prevFiles,
          [name]: file.name,
        }));
      }

      const formData = new FormData();
      formData.append("documentData", file);

      try {
        const response = await axios.post(
          `${Constant.BASE_URL}hrms/addDocuments`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        const fileUrl = response.data.photoURL;
        console.log("Uploaded file URL:", fileUrl);

        if (section === "cheque") {
          setChequePhoto(fileUrl);
        } else if (section === "employee") {
          setEmployeeData((prevData) => ({
            ...prevData,
            [name]: fileUrl,
          }));
        } else if (section === "job" && index !== null) {
          const updatedCompanies = [...companyData];
          updatedCompanies[index][name] = fileUrl;
          setCompanyData(updatedCompanies);
        }
      } catch (error) {
        console.error("Error uploading file:", error);
        alert("Failed to upload file. Please try again.");
      }
    } else {
      // Handle non-file input
      if (section === "cheque") {
        setChequePhoto(null);
      } else if (section === "employee") {
        if (name === "department") {
          setEmployeeData((prevData) => ({
            ...prevData,
            department: value,
          }));
        } else if (name === "manager") {
          setEmployeeData((prevData) => ({
            ...prevData,
            reporting_manager: value,
          }));
        } else {
          setEmployeeData((prevData) => ({
            ...prevData,
            [name]: value,
          }));
        }
      } else if (section === "job" && index !== null) {
        const updatedCompanies = [...companyData];
        updatedCompanies[index][name] = value;
        setCompanyData(updatedCompanies);
      } else if (section === "Family" && index !== null) {
        const updatedFamily = [...familyDetail];
        updatedFamily[index][name] = value;
        setFamilyDetail(updatedFamily);
      }
    }
  };

  const AddFamily = () => {};
  console.log("📝 Final companyData:");
  console.table(companyData);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      alert("Please fix the errors before submitting.");
      return;
    }

    try {
      const updatedEmployeeData = {
        employeeData: {
          ...employeeData,
        },
        workingCompany: companyData,
        familyDetail: familyDetail || [],
      };

      console.log("Payload before submission:", updatedEmployeeData);

      const response = await fetch(
        `${Constant.BASE_URL}hrms/onboardingEmployee`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(updatedEmployeeData),
        }
      );

      // This part handles HTTP-level errors (e.g., 404 Not Found, 500 Internal Server Error)
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(
          `Server responded with status ${response.status}: ${errorText}`
        );
      }

      const data = await response.json();

      // --- Start of Change ---
      // Here, we check the business logic status from the API response body.
      // Based on other API calls in your code, we assume a `status` of 1 means success.
      if (data && data.status === 1) {
        console.log("Success:", data);
        alert("Employee added successfully!");
        // window.location.reload(); // You can uncomment this to refresh the page on success
      } else {
        // If status is not 1, the employee was not added.
        // We throw an error with the message from the API to be caught by the catch block.
        throw new Error(
          data.message || "An unknown error occurred while adding the employee."
        );
      }
      // --- End of Change ---
    } catch (error) {
      console.error("Error during employee onboarding:", error.message);
      // This alert will now show more specific errors from the API.
      alert(`Failed to add employee. Reason: ${error.message}`);
    }
  };
  const preventLeadingSpace = (e) => {
    // Check if the pressed key is a space and if the input field is currently empty
    if (e.key === " " && e.currentTarget.value.length === 0) {
      // Prevent the default action (typing a space)
      e.preventDefault();
    }
  };
  // Handle Redux-based file upload
  const handleFileChange = (e) => {
    if (e.target.files.length) {
      const formData = new FormData();
      formData.append("passport", e.target.files[0]);
      dispatch(updateAadhaarImageBack(formData));
    }
  };
  const validateForm = () => {
    const newErrors = {};

    // 1. Employee ID Null Check
    if (!employeeData.employee_id || !employeeData.employee_id.trim()) {
      newErrors.employee_id = "Employee ID is required.";
    }

    // 2. Email Null Check
    if (!employeeData.email || !employeeData.email.trim()) {
      newErrors.email = "Email is required.";
    }
    // 3. Email Format Check (using a simple regex)
    else if (!/\S+@\S+\.\S+/.test(employeeData.email)) {
      newErrors.email = "Email address is invalid.";
    }

    setErrors(newErrors);

    // Return true if there are no errors, false otherwise
    return Object.keys(newErrors).length === 0;
  };

  const deleteFile = (fieldName, index = null) => {
    if (index !== null) {
      // Handle file deletion within companyData array
      const updatedCompanyData = [...companyData];
      updatedCompanyData[index][fieldName] = null;
      setCompanyData(updatedCompanyData);
    } else {
      // Handle file deletion within employeeData object
      setEmployeeData((prevData) => ({
        ...prevData,
        [fieldName]: null,
      }));
    }
    setPhotoFile((prev) => {
      const newPhotoFile = { ...prev };
      delete newPhotoFile[fieldName];
      return newPhotoFile;
    });
  };

  const handleWorkLocationChange = (e) => {
    const { value } = e.target;

    handleInputChange(e, "employee");

    if (value) {
      const filtered = workLocations.filter((location) =>
        location.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredWorkLocations(filtered);
    } else {
      setFilteredWorkLocations(workLocations);
    }
  };

  const handleWorkLocationSelect = (location) => {
    const syntheticEvent = {
      target: {
        name: "work_location",
        value: location,
      },
    };
    handleInputChange(syntheticEvent, "employee");
    setShowWorkLocationDropdown(false);
  };

  return (
    <div className="AgentCustomer">
      {/*<!-- Main Body --> */}

      <div className="container-fluid my-2">
        <div className="row">
          <main className="mainBodyContainer">
            <div className="row my-2">
              <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 py-2 px-3">
                <div className="py-3">
                  <h4
                    className="text-uppercase text-center"
                    style={{
                      fontFamily: "ErasDemiITC",
                      fontWeight: "normal",
                    }}
                  >
                    Onboard Employee
                  </h4>
                </div>
              </div>
            </div>
            <div className="row py-0">
              <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 py-0 px-3">
                <div className="px-2 rounded-3">
                  <hr className="my-0" />
                </div>
              </div>
            </div>
            <div className="row py-0">
              <div className="multisteps-form">
                <div className="row"></div>

                <div className="row">
                  <div className="col-12 col-lg-12 m-auto">
                    <form className="multisteps-form__form">
                      <div
                        className="multisteps-form__panel rounded js-active"
                        data-animation="scaleIn"
                      >
                        <div
                          className="bg-white p-4 shadow  pb-5 rounded-3"
                          style={{
                            marginLeft: "0.8rem",
                            marginRight: "0.8rem",
                          }}
                        >
                          <div className="d-flex justify-content-between border-bottom pb-3">
                            <div className="bg-white">
                              <h4
                                className="text-capitalize icueTextPrimary"
                                style={{ fontFamily: "ErasDemiITC" }}
                              >
                                Personal information
                              </h4>
                            </div>
                            <div className="bg-white"></div>
                          </div>
                          <div
                            className="multisteps-form__content"
                            style={{ fontFamily: "Calibri" }}
                          >
                            <div className="row pt-4">
                              <div className="row">
                                <div className=" form col-3 d-flex flex-column">
                                  <label htmlFor="uploadPhoto">
                                    Upload Your Photo*
                                  </label>

                                  <div className="pt-2">
                                    {!employeeData.profile_pic &&
                                    !isDisabled ? (
                                      <div>
                                        <label>
                                          {photoLoad ? (
                                            <div className="Group">
                                              <span className="spinner-border spinner-border-lg"></span>
                                            </div>
                                          ) : (
                                            <img
                                              style={{ height: "190px" }}
                                              src={ImagePlaceholder}
                                              alt="placeholder"
                                            />
                                          )}
                                          <input
                                            type="file"
                                            className="d-none"
                                            name="profile_pic"
                                            onKeyDown={preventLeadingSpace}
                                            onChange={(e) =>
                                              handleInputChange(e, "employee")
                                            }
                                          />
                                        </label>
                                        {errors.profile_pic && (
                                          // Show error message if photoFile validation fails
                                          <p className="p-error">
                                            {errors.profile_pic}
                                          </p>
                                        )}
                                      </div>
                                    ) : (
                                      <div className="row form-group">
                                        <div className="img-preview">
                                          <img
                                            src={employeeData.profile_pic} // Ensure this accesses the correct photo key
                                            alt="Employee Photo Preview"
                                            style={{ maxHeight: "190px" }}
                                          />
                                          {!isDisabled && (
                                            <img
                                              onClick={() =>
                                                deleteFile("profile_pic")
                                              }
                                              // Ensure deleteFile removes the correct key
                                              className="clear"
                                              src={X}
                                              alt="clear-preview"
                                            />
                                          )}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                                <div className="  col-6 d-flex flex-column">
                                  <label htmlFor="uploadbResume ">
                                    Upload Resume
                                  </label>

                                  <div className="pt-2">
                                    {!employeeData.resume && !isDisabled ? (
                                      // Check if the photo is not set and the field is not disabled
                                      <div>
                                        <label>
                                          {photoLoad ? (
                                            <div className="Group">
                                              <span className="spinner-border spinner-border-lg"></span>
                                            </div>
                                          ) : (
                                            <img
                                              style={{ height: "190px" }}
                                              src={ImagePlaceholder}
                                              alt="placeholder"
                                            />
                                          )}
                                          <input
                                            type="file"
                                            className="d-none"
                                            name="resume"
                                            onKeyDown={preventLeadingSpace}
                                            onChange={(e) =>
                                              handleInputChange(e, "employee")
                                            }
                                          />
                                        </label>
                                        {errors.resume && (
                                          // Show error message if photoFile validation fails
                                          <p className="p-error">
                                            {errors.resume}
                                          </p>
                                        )}
                                      </div>
                                    ) : (
                                      <div className="row form-group">
                                        <div className="img-preview">
                                          <img
                                            src={employeeData.resume} // Ensure this accesses the correct photo key
                                            alt="Employee Resume Preview"
                                            style={{ maxHeight: "190px" }}
                                          />
                                          {!isDisabled && (
                                            <img
                                              onClick={() =>
                                                deleteFile("resume")
                                              }
                                              // Ensure deleteFile removes the correct key
                                              className="clear"
                                              src={X}
                                              alt="clear-preview"
                                            />
                                          )}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                              <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                <label
                                  htmlFor="icuePersonalFormCueMemTitle"
                                  className="form-label icueTextPrimary icuePersonalInfoLabel"
                                >
                                  Title
                                </label>
                                <select
                                  value={employeeData.title}
                                  onChange={(e) =>
                                    handleInputChange(e, "employee")
                                  }
                                  id="icuePersonalFormCueMemTitle"
                                  name="title"
                                  className="form-select text-uppercase icuePersonalFormInput   bg-white icuePerFormSel text-muted"
                                >
                                  <option value="mr.">mr.</option>
                                  <option value="ms.">ms.</option>
                                  <option value="mrs.">mrs.</option>
                                </select>
                              </div>
                              <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                <label
                                  htmlFor="icuePersonalFormCueMemFname"
                                  className="form-label icueTextPrimary icuePersonalInfoLabel"
                                >
                                  First Name
                                </label>
                                <input
                                  value={employeeData.first_name}
                                  onKeyDown={preventLeadingSpace}
                                  onChange={(e) =>
                                    handleInputChange(e, "employee")
                                  }
                                  type="text"
                                  id="icuePersonalFormCueMemFname"
                                  name="first_name"
                                  className="form-control text-uppercase icuePersonalFormInput bg-white text-muted"
                                />
                              </div>

                              <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                <label
                                  htmlFor="icuePersonalFormCueMemLName"
                                  className="form-label icueTextPrimary icuePersonalInfoLabel"
                                >
                                  Last name
                                </label>
                                <input
                                  value={employeeData.last_name}
                                  onKeyDown={preventLeadingSpace}
                                  onChange={(e) =>
                                    handleInputChange(e, "employee")
                                  }
                                  type="text"
                                  id="icuePersonalFormCueMemLName"
                                  name="last_name"
                                  className="form-control text-uppercase icuePersonalFormInput   bg-white text-muted"
                                  defaultValue=" "
                                />
                              </div>
                              <div></div>

                              <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12 pt-3">
                                <label
                                  htmlFor="icuePersonalFormCueMemEmail"
                                  className="form-label icueTextPrimary icuePersonalInfoLabel"
                                >
                                  E-mail
                                </label>
                                <input
                                  value={employeeData.email}
                                  onChange={(e) =>
                                    handleInputChange(e, "employee")
                                  }
                                  onKeyDown={preventLeadingSpace} // Assuming you have this
                                  type="email"
                                  id="icuePersonalFormCueMemEmail"
                                  name="email"
                                  className="form-control text-uppercase icuePersonalFormInput   bg-white text-muted"
                                  defaultValue="xyz@gmail.com"
                                />
                                {/* Add this line to display the error */}
                                {errors.email && (
                                  <p className="p-error">{errors.email}</p>
                                )}
                              </div>
                              {/* <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12 pt-3">
                                <label
                                  htmlFor="icuePersonalFormCueMemPhoneNo"
                                  className="form-label icueTextPrimary icuePersonalInfoLabel"
                                >
                                  Contact Number
                                </label>
                                <input
                                  value={employeeData.contact_number}
                                  onKeyDown={preventLeadingSpace}
                                  onChange={(e) =>
                                    handleInputChange(e, "employee")
                                  }
                                  type="number"
                                  id="icuePersonalFormCueMemPhoneNo"
                                  name="contact_number"
                                  className="form-control text-uppercase icuePersonalFormInput   bg-white text-muted"
                                  defaultValue="xxxxxxxxxx"
                                />
                              </div>  */}
                              <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12 pt-3">
                                <label
                                  htmlFor="icuePersonalFormCueMemPhoneNo"
                                  className="form-label icueTextPrimary icuePersonalInfoLabel"
                                >
                                  Contact Number
                                </label>
                                <input
                                  value={employeeData.contact_number}
                                  onKeyDown={preventLeadingSpace}
                                  onChange={(e) => {
                                    // Create a new value that only contains digits by removing non-numeric characters.
                                    const numericValue = e.target.value.replace(
                                      /[^0-9]/g,
                                      ""
                                    );

                                    // Create a synthetic event object to pass to your existing handler.
                                    // This ensures the value being saved to the state is always the sanitized numeric value.
                                    const newEvent = {
                                      target: {
                                        name: "contact_number",
                                        value: numericValue,
                                      },
                                    };
                                    handleInputChange(newEvent, "employee");
                                  }}
                                  type="text"
                                  maxLength="10"
                                  id="icuePersonalFormCueMemPhoneNo"
                                  name="contact_number"
                                  className="form-control text-uppercase icuePersonalFormInput bg-white text-muted"
                                  placeholder="xxxxxxxxxx"
                                />
                              </div>
                              <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12 pt-3">
                                <label
                                  htmlFor="icuePersonalFormCueMemMobNo"
                                  className="form-label icueTextPrimary icuePersonalInfoLabel"
                                >
                                  Emergency Contact Number
                                </label>
                                <input
                                  value={employeeData.emergency_contact_number}
                                  onKeyDown={preventLeadingSpace}
                                  onChange={(e) =>
                                    handleInputChange(e, "employee")
                                  }
                                  maxLength="10"
                                  type="text"
                                  id="icuePersonalFormCueMemMobNo"
                                  name="emergency_contact_number"
                                  className="form-control text-uppercase icuePersonalFormInput   bg-white text-muted"
                                  placeholder="xxxxxxxxxx"
                                />
                              </div>

                              <div></div>
                              <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12 pt-3">
                                <label
                                  htmlFor="icuePersonalFormCueMemPanNo"
                                  className="form-label icueTextPrimary icuePersonalInfoLabel"
                                >
                                  Date Of Birth
                                </label>
                                <input
                                  value={
                                    employeeData.dob
                                      ? new Date(employeeData.dob)
                                          .toISOString()
                                          .slice(0, 10)
                                      : ""
                                  }
                                  onKeyDown={preventLeadingSpace}
                                  onChange={(e) =>
                                    handleInputChange(e, "employee")
                                  }
                                  type="date"
                                  id="icuePersonalFormCueMemPanNo"
                                  name="dob"
                                  className="form-control text-uppercase icuePersonalFormInput   bg-white text-muted"
                                  defaultValue="alwpg5809l"
                                />
                              </div>
                              <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12 pt-3">
                                <label
                                  htmlFor=""
                                  className="form-label icueTextPrimary icuePersonalInfoLabel"
                                >
                                  Gender
                                </label>
                                <select
                                  value={employeeData.gender}
                                  onChange={(e) =>
                                    handleInputChange(e, "employee")
                                  }
                                  id=""
                                  name="gender"
                                  className="form-select text-capitalize icuePersonalFormInput   bg-white icuePerFormSel text-muted"
                                >
                                  <option value="selft employed">Male</option>
                                  <option value="self">Female</option>
                                  <option value="employed">Other</option>
                                </select>
                              </div>
                              <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12 pt-3">
                                <label
                                  htmlFor="icuePersonalFormCueMemProfession"
                                  className="form-label icueTextPrimary icuePersonalInfoLabel"
                                >
                                  Marital Status
                                </label>
                                <select
                                  value={employeeData.marital_status}
                                  onChange={(e) =>
                                    handleInputChange(e, "employee")
                                  }
                                  id="icuePersonalFormCueMemProfession"
                                  name="marital_status"
                                  className="form-select text-capitalize icuePersonalFormInput   bg-white icuePerFormSel text-muted"
                                >
                                  <option value="selft employed">Yes</option>
                                  <option value="self">No</option>
                                </select>
                              </div>
                              <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12 pt-3">
                                <label
                                  htmlFor="icuePersonalFormCueMemLName"
                                  className="form-label icueTextPrimary icuePersonalInfoLabel"
                                >
                                  Blood Group
                                </label>
                                <input
                                  value={employeeData.blood_group}
                                  onKeyDown={preventLeadingSpace}
                                  onChange={(e) =>
                                    handleInputChange(e, "employee")
                                  }
                                  type="text"
                                  id="icuePersonalFormCueMemLName"
                                  name="blood_group"
                                  className="form-control text-uppercase icuePersonalFormInput   bg-white text-muted"
                                  defaultValue=" "
                                />
                              </div>
                              <Accordion
                                defaultActiveKey="0"
                                flush
                                className="pt-5"
                              >
                                <Accordion.Item eventKey="0">
                                  <Accordion.Header className="icueTextPrimary ">
                                    Contact Details
                                  </Accordion.Header>
                                  <Accordion.Body>
                                    {" "}
                                    <div className="col-xxl-6 col-xl-6 col-lg-4 col-md-4 col-sm-6 col-12 pt-3">
                                      <label
                                        htmlFor="icuePersonalFormCueMemRegAdd"
                                        className="form-label icueTextPrimary icuePersonalInfoLabel"
                                      >
                                        Residential Address
                                      </label>

                                      <textarea
                                        // value={residentialAddress.address}
                                        // onChange={handleResidentialChange}
                                        value={employeeData.residential_address}
                                        onChange={(e) =>
                                          handleInputChange(e, "employee")
                                        }
                                        className="form-control text-uppercase icuePersonalFormInput   bg-white text-muted"
                                        type="text"
                                        name="residential_address"
                                        rows="3"
                                      ></textarea>
                                    </div>
                                    <div className="row pt-2">
                                      <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                        <label
                                          htmlFor="icuePersonalFormCueMemRegAdd"
                                          className="form-label icueTextPrimary icuePersonalInfoLabel"
                                        >
                                          Landmark
                                        </label>
                                        <input
                                          // value={residentialAddress.landmark}
                                          value={employeeData.landmark}
                                          onKeyDown={preventLeadingSpace}
                                          // onChange={handleResidentialChange}
                                          // value={employeeData.city}
                                          onChange={(e) =>
                                            handleInputChange(e, "employee")
                                          }
                                          type="text"
                                          id="icuePersonalFormCueMemRegAdd"
                                          name="landmark"
                                          className="form-control text-uppercase icuePersonalFormInput   bg-white text-muted"
                                        />
                                      </div>{" "}
                                      {/* <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                        <label
                                          htmlFor=""
                                          className="form-label icueTextPrimary icuePersonalInfoLabel"
                                        >
                                          State
                                        </label>
                                        <input
                                          value={employeeData.state}
                                          onKeyDown={preventLeadingSpace}
                                          onChange={(e) =>
                                            handleInputChange(e, "employee")
                                          }
                                          type="text"
                                          id=""
                                          name="state"
                                          className="form-control text-uppercase icuePersonalFormInput   bg-white text-muted"
                                          defaultValue=" "
                                        />
                                      </div> */}
                                      <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                        <label
                                          htmlFor="residentialState"
                                          className="form-label icueTextPrimary icuePersonalInfoLabel"
                                        >
                                          State
                                        </label>
                                        <select
                                          id="residentialState"
                                          name="state"
                                          className="form-select text-uppercase icuePersonalFormInput bg-white icuePerFormSel text-muted"
                                          value={employeeData.state}
                                          onChange={handleStateChange}
                                        >
                                          <option value="">Select State</option>
                                          {states.map((stateObj, index) => (
                                            <option
                                              key={index}
                                              value={stateObj.state}
                                            >
                                              {stateObj.state}
                                            </option>
                                          ))}
                                        </select>
                                      </div>
                                      <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                        <label
                                          htmlFor="residentialCity"
                                          className="form-label icueTextPrimary icuePersonalInfoLabel"
                                        >
                                          City
                                        </label>
                                        <select
                                          id="residentialCity"
                                          name="city"
                                          className="form-select text-uppercase icuePersonalFormInput bg-white icuePerFormSel text-muted"
                                          value={employeeData.city}
                                          onChange={handleCityChange}
                                          disabled={cities.length === 0}
                                        >
                                          <option value="">Select City</option>
                                          {cities.map((cityObj, index) => (
                                            <option
                                              key={index}
                                              value={cityObj.city}
                                            >
                                              {cityObj.city}
                                            </option>
                                          ))}
                                        </select>
                                      </div>
                                      {/* <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                        <label
                                          htmlFor="icuePersonalFormCueMemPin"
                                          className="form-label icueTextPrimary icuePersonalInfoLabel"
                                        >
                                          Pincode
                                        </label>
                                        <input
                                          value={employeeData.pincode}
                                          onKeyDown={preventLeadingSpace}
                                          onChange={(e) =>
                                            handleInputChange(e, "employee")
                                          }
                                          type="text"
                                          id="icuePersonalFormCueMemPin"
                                          name="pincode"
                                          className="form-control text-uppercase icuePersonalFormInput   bg-white text-muted"
                                          defaultValue={12211}
                                        />
                                      </div> */}
                                      <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                        <label
                                          htmlFor="residentialPincode"
                                          className="form-label icueTextPrimary icuePersonalInfoLabel"
                                        >
                                          Pincode
                                        </label>
                                        <select
                                          id="residentialPincode"
                                          name="pincode"
                                          className="form-select text-uppercase icuePersonalFormInput bg-white icuePerFormSel text-muted"
                                          value={employeeData.pincode}
                                          onChange={(e) =>
                                            handleInputChange(e, "employee")
                                          }
                                          disabled={pincodes.length === 0}
                                        >
                                          <option value="">
                                            Select Pincode
                                          </option>
                                          {pincodes.map((pincodeObj, index) => (
                                            <option
                                              key={index}
                                              value={pincodeObj.pincode}
                                            >
                                              {pincodeObj.pincode}
                                            </option>
                                          ))}
                                        </select>
                                      </div>
                                      <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                        <label
                                          htmlFor=""
                                          className="form-label icueTextPrimary icuePersonalInfoLabel"
                                        >
                                          Country
                                        </label>
                                        <input
                                          value={employeeData.country}
                                          onKeyDown={preventLeadingSpace}
                                          onChange={(e) =>
                                            handleInputChange(e, "employee")
                                          }
                                          type="text"
                                          id=""
                                          name="country"
                                          className="form-control text-uppercase icuePersonalFormInput   bg-white text-muted"
                                          defaultValue=" "
                                        />
                                      </div>
                                    </div>
                                    <div className="col-xxl-6 col-xl-6 col-lg-4 col-md-4 col-sm-6 col-12 pt-3">
                                      <label
                                        htmlFor="icuePersonalFormCueMemRegAdd"
                                        className="form-label icueTextPrimary icuePersonalInfoLabel"
                                      >
                                        Permanent Address
                                      </label>

                                      <textarea
                                        value={employeeData.permanent_address}
                                        onChange={(e) => {
                                          handleInputChange(e, "employee");
                                        }}
                                        className="form-control text-uppercase icuePersonalFormInput   bg-white text-muted"
                                        type="text"
                                        name="permanent_address"
                                        rows="3"
                                      ></textarea>
                                    </div>
                                    <div className="row pt-2">
                                      <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                        <label
                                          htmlFor="icuePersonalFormCueMemRegAdd"
                                          className="form-label icueTextPrimary icuePersonalInfoLabel"
                                        >
                                          Landmark
                                        </label>
                                        <input
                                          value={employeeData.pa_landmark}
                                          onKeyDown={preventLeadingSpace}
                                          onChange={(e) =>
                                            handleInputChange(e, "employee")
                                          }
                                          type="text"
                                          id="icuePersonalFormCueMemRegAdd"
                                          name="pa_landmark"
                                          className="form-control text-uppercase icuePersonalFormInput   bg-white text-muted"
                                          defaultValue=""
                                        />
                                      </div>

                                      <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                        <label
                                          htmlFor="permanentState"
                                          className="form-label icueTextPrimary icuePersonalInfoLabel"
                                        >
                                          State
                                        </label>
                                        <select
                                          id="permanentState"
                                          name="pa_state"
                                          className="form-select text-uppercase icuePersonalFormInput bg-white icuePerFormSel text-muted"
                                          value={employeeData.pa_state}
                                          onChange={handlePermanentStateChange}
                                        >
                                          <option value="">Select State</option>
                                          {states.map((stateObj, index) => (
                                            <option
                                              key={index}
                                              value={stateObj.state}
                                            >
                                              {stateObj.state}
                                            </option>
                                          ))}
                                        </select>
                                      </div>

                                      <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                        <label
                                          htmlFor="permanentCity"
                                          className="form-label icueTextPrimary icuePersonalInfoLabel"
                                        >
                                          City
                                        </label>
                                        <select
                                          id="permanentCity"
                                          name="pa_city"
                                          className="form-select text-uppercase icuePersonalFormInput bg-white icuePerFormSel text-muted"
                                          value={employeeData.pa_city}
                                          onChange={handlePermanentCityChange}
                                          disabled={
                                            permanentCities.length === 0
                                          }
                                        >
                                          <option value="">Select City</option>
                                          {permanentCities.map(
                                            (cityObj, index) => (
                                              <option
                                                key={index}
                                                value={cityObj.city}
                                              >
                                                {cityObj.city}
                                              </option>
                                            )
                                          )}
                                        </select>
                                      </div>

                                      <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                        <label
                                          htmlFor="permanentPincode"
                                          className="form-label icueTextPrimary icuePersonalInfoLabel"
                                        >
                                          Pincode
                                        </label>
                                        <select
                                          id="permanentPincode"
                                          name="pa_pincode"
                                          className="form-select text-uppercase icuePersonalFormInput bg-white icuePerFormSel text-muted"
                                          value={employeeData.pa_pincode}
                                          onChange={(e) =>
                                            handleInputChange(e, "employee")
                                          } // Just update the state
                                          disabled={
                                            permanentPincodes.length === 0
                                          } // Disable if no city is selected
                                        >
                                          <option value="">
                                            Select Pincode
                                          </option>
                                          {permanentPincodes.map(
                                            (pincodeObj, index) => (
                                              <option
                                                key={index}
                                                value={pincodeObj.pincode}
                                              >
                                                {pincodeObj.pincode}
                                              </option>
                                            )
                                          )}
                                        </select>
                                      </div>
                                      <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                        <label
                                          htmlFor=""
                                          className="form-label icueTextPrimary icuePersonalInfoLabel"
                                        >
                                          Country
                                        </label>
                                        <input
                                          value={employeeData.pa_country}
                                          onKeyDown={preventLeadingSpace}
                                          onChange={(e) =>
                                            handleInputChange(e, "employee")
                                          }
                                          type="text"
                                          id=""
                                          name="pa_country"
                                          className="form-control text-uppercase icuePersonalFormInput   bg-white text-muted"
                                          defaultValue=" "
                                        />
                                      </div>
                                    </div>
                                  </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="1">
                                  <Accordion.Header className="icueTextPrimary">
                                    Bank Details
                                  </Accordion.Header>
                                  <Accordion.Body>
                                    <div className="row pt-2">
                                      {/* Bank Name */}
                                      <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                        <label
                                          htmlFor="bankName"
                                          className="form-label icueTextPrimary icuePersonalInfoLabel"
                                        >
                                          Bank Name
                                        </label>
                                        <input
                                          type="text"
                                          value={employeeData.bank_name}
                                          onKeyDown={preventLeadingSpace}
                                          onChange={(e) => {
                                            handleInputChange(e, "employee");
                                          }}
                                          id="bankName"
                                          name="bank_name"
                                          className="form-control text-uppercase icuePersonalFormInput bg-white text-muted"
                                          defaultValue=""
                                        />
                                      </div>

                                      {/* Account Holder Name */}
                                      <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                        <label
                                          htmlFor="accHolder"
                                          className="form-label icueTextPrimary icuePersonalInfoLabel"
                                        >
                                          Account Holder Name
                                        </label>
                                        <input
                                          value={
                                            employeeData.account_holder_name
                                          }
                                          onChange={(e) => {
                                            handleInputChange(e, "employee");
                                          }}
                                          onKeyDown={preventLeadingSpace}
                                          type="text"
                                          id="accHolder"
                                          name="account_holder_name"
                                          className="form-control text-uppercase icuePersonalFormInput bg-white text-muted"
                                          defaultValue=""
                                        />
                                      </div>

                                      {/* Account Number */}
                                      <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                        <label
                                          htmlFor="accNumber"
                                          className="form-label icueTextPrimary icuePersonalInfoLabel"
                                        >
                                          Account Number
                                        </label>
                                        <input
                                          value={
                                            employeeData.bank_account_number
                                          }
                                          onChange={(e) => {
                                            handleInputChange(e, "employee");
                                          }}
                                          onKeyDown={preventLeadingSpace}
                                          type="Text"
                                          id="accNumber"
                                          name="bank_account_number"
                                          className="form-control text-uppercase icuePersonalFormInput bg-white text-muted"
                                          defaultValue=""
                                        />
                                      </div>

                                      {/* IFSC Code */}
                                      <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                        <label
                                          htmlFor="ifscCode"
                                          className="form-label icueTextPrimary icuePersonalInfoLabel"
                                        >
                                          IFSC Code
                                        </label>
                                        <input
                                          value={employeeData.ifsc_code}
                                          onChange={(e) => {
                                            handleInputChange(e, "employee");
                                          }}
                                          onKeyDown={preventLeadingSpace}
                                          type="text"
                                          id="ifscCode"
                                          name="ifsc_code"
                                          className="form-control text-uppercase icuePersonalFormInput bg-white text-muted"
                                          defaultValue=""
                                        />
                                      </div>

                                      {/* Upload Cheque Photo */}
                                      <div className="col-12 pt-3">
                                        <label
                                          htmlFor="chequePhoto"
                                          className="form-label icueTextPrimary"
                                        >
                                          Upload Cancelled Cheque Photo
                                        </label>
                                        <div>
                                          {!employeeData.bank_document_upload &&
                                          !isDisabled ? (
                                            <div>
                                              <label>
                                                {photoLoad ? (
                                                  <div className="Group">
                                                    <span className="spinner-border spinner-border-lg"></span>
                                                  </div>
                                                ) : (
                                                  <img
                                                    style={{ height: "190px" }}
                                                    src={ImagePlaceholder}
                                                    alt="placeholder"
                                                  />
                                                )}
                                                <input
                                                  type="file"
                                                  onKeyDown={
                                                    preventLeadingSpace
                                                  }
                                                  className="d-none"
                                                  name="bank_document_upload"
                                                  onChange={(e) =>
                                                    handleInputChange(
                                                      e,
                                                      "employee"
                                                    )
                                                  }
                                                />
                                              </label>
                                              {errors.bank_document_upload && (
                                                // Show error message if validation fails
                                                <p className="p-error">
                                                  {errors.bank_document_upload}
                                                </p>
                                              )}
                                            </div>
                                          ) : (
                                            <div className="row form-group">
                                              <div className="img-preview">
                                                <img
                                                  src={
                                                    employeeData.bank_document_upload
                                                  }
                                                  alt="Cheque Photo Preview"
                                                  style={{ maxHeight: "190px" }}
                                                />
                                                <img
                                                  onClick={() =>
                                                    deleteFile(
                                                      "bank_document_upload"
                                                    )
                                                  }
                                                  className="clear"
                                                  src={X}
                                                  alt="clear-preview"
                                                />
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </Accordion.Body>
                                </Accordion.Item>

                                <Accordion.Item eventKey="2">
                                  <Accordion.Header className="icueTextPrimary ">
                                    Family Details
                                  </Accordion.Header>
                                  <Accordion.Body>
                                    {familyDetail.map((Family, index) => (
                                      <div className="row pt-2" key={index}>
                                        <div className="bg-white">
                                          {/* <FontAwesomeIcon
                                  icon={faTrash}
                                  type="button"
                                  className="btn btn-transparent icueTextInfoLight"
                                  id="icueEditGennInfoDetails"
                                  onClick={() => removeJobSection(index)}
                                  style={{
                                    float: "right",
                                    color: "red",
                                    cursor: "pointer",
                                    fontSize: "20px",
                                  }}
                                /> */}
                                          <div className="d-flex justify-content-end">
                                            {familyDetail.length > 1 && (
                                              <FontAwesomeIcon
                                                icon={faTrash}
                                                type="button"
                                                onClick={() =>
                                                  deleteFamily(index)
                                                }
                                                style={{
                                                  color: "red",
                                                  cursor: "pointer",
                                                  fontSize: "20px",
                                                }}
                                              />
                                            )}
                                          </div>
                                        </div>
                                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                          <label
                                            htmlFor={`member_name-${index}`}
                                            className="form-label icueTextPrimary icuePersonalInfoLabel"
                                          >
                                            Name of the Family Member
                                          </label>
                                          <input
                                            onKeyDown={preventLeadingSpace}
                                            type="text"
                                            id={`member_name-${index}`}
                                            value={Family.member_name}
                                            name="member_name"
                                            onChange={(e) =>
                                              handleInputChange(
                                                e,
                                                "Family",
                                                index
                                              )
                                            }
                                            className="form-control text-uppercase icuePersonalFormInput   bg-white text-muted"
                                            defaultValue=""
                                          />
                                        </div>
                                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                          <label
                                            htmlFor={`Relation-${index}`}
                                            className="form-label icueTextPrimary icuePersonalInfoLabel"
                                          >
                                            Relation
                                          </label>
                                          <input
                                            type="text"
                                            onKeyDown={preventLeadingSpace}
                                            id={`Relation-${index}`}
                                            value={Family.relation}
                                            name="relation"
                                            onChange={(e) =>
                                              handleInputChange(
                                                e,
                                                "Family",
                                                index
                                              )
                                            }
                                            className="form-control text-uppercase icuePersonalFormInput   bg-white text-muted"
                                            defaultValue=""
                                          />
                                        </div>
                                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                          <label
                                            htmlFor={`Occupation-${index}`}
                                            className="form-label icueTextPrimary icuePersonalInfoLabel"
                                          >
                                            Date of Birth
                                          </label>
                                          <input
                                            type="Date"
                                            onKeyDown={preventLeadingSpace}
                                            id={`Occupation-${index}`}
                                            value={Family.member_dob}
                                            name="member_dob"
                                            onChange={(e) =>
                                              handleInputChange(
                                                e,
                                                "Family",
                                                index
                                              )
                                            }
                                            className="form-control text-uppercase icuePersonalFormInput   bg-white text-muted"
                                            defaultValue=""
                                          />
                                        </div>
                                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                          <label
                                            htmlFor={`Occupation-${index}`}
                                            className="form-label icueTextPrimary icuePersonalInfoLabel"
                                          >
                                            Occupation
                                          </label>
                                          <input
                                            type="text"
                                            onKeyDown={preventLeadingSpace}
                                            id={`Occupation-${index}`}
                                            value={Family.occupation}
                                            name="occupation"
                                            onChange={(e) =>
                                              handleInputChange(
                                                e,
                                                "Family",
                                                index
                                              )
                                            }
                                            className="form-control text-uppercase icuePersonalFormInput   bg-white text-muted"
                                            defaultValue=" "
                                          />
                                        </div>
                                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                          <label
                                            htmlFor={`Contact-${index}`}
                                            className="form-label icueTextPrimary icuePersonalInfoLabel"
                                          >
                                            Contact number
                                          </label>
                                          <input
                                            value={Family.member_contact_number}
                                            onKeyDown={preventLeadingSpace}
                                            maxLength="10"
                                            onChange={(e) =>
                                              handleInputChange(
                                                e,
                                                "Family",
                                                index
                                              )
                                            }
                                            type="text"
                                            id={`Contact-${index}`}
                                            name="member_contact_number"
                                            className="form-control text-uppercase icuePersonalFormInput   bg-white text-muted"
                                            defaultValue=" "
                                          />
                                        </div>
                                      </div>
                                    ))}
                                    <button
                                      type="button"
                                      onClick={AddFamilyMember}
                                      style={{
                                        marginTop: "20px",
                                        padding: "5px 10px",
                                        backgroundColor: "#007bff",
                                        color: "#fff",
                                        border: "none",
                                        borderRadius: "5px",
                                        cursor: "pointer",
                                      }}
                                    >
                                      Add More Member
                                    </button>
                                  </Accordion.Body>
                                </Accordion.Item>
                              </Accordion>
                              <div>
                                <hr />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="bg-white shadow p-4 pb-5 rounded-3"
                          style={{
                            marginTop: "4rem",
                            marginLeft: "0.8rem",
                            marginRight: "0.8rem",
                          }}
                        >
                          <div className="d-flex justify-content-between pb-4 border-bottom py-0 mb-3">
                            <div className="bg-white">
                              <h4
                                className="text-capitalize icueTextPrimary"
                                style={{ fontFamily: "ErasDemiITC" }}
                              >
                                Educational Information
                              </h4>
                            </div>
                            <div className="bg-white"></div>
                          </div>
                          <div
                            className="multisteps-form__content"
                            style={{ fontFamily: "Calibri" }}
                          >
                            <div className="row">
                              <div className="qualification-section row">
                                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                  <label
                                    htmlFor="icueGenFormAlreadyInsured"
                                    className="form-label icueTextPrimary icueGenInfoLabel mt-3"
                                  >
                                    Board of Education
                                  </label>
                                  <select
                                    value={employeeData.board_of_education}
                                    onChange={(e) =>
                                      handleInputChange(e, "employee")
                                    }
                                    id="icueGenFormAlreadyInsured"
                                    name="board_of_education"
                                    className="form-select text-uppercase icueGenFormInput   bg-white icueGenFormSel text-muted"
                                  >
                                    <option value="HBSE">HBSE</option>
                                    <option value="CBSE">CBSE</option>
                                    <option value="ICSE">ICSE</option>
                                  </select>
                                </div>
                                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                  <label
                                    htmlFor="icueGenFormTypeInsurance"
                                    className="form-label icueTextPrimary icueGenInfoLabel mt-3"
                                  >
                                    Class 10 Percentage
                                  </label>
                                  <input
                                    value={employeeData.calss_10_percentage}
                                    onKeyDown={preventLeadingSpace}
                                    onChange={(e) =>
                                      handleInputChange(e, "employee")
                                    }
                                    type="text"
                                    id="icueGenFormTypeInsurance"
                                    name="calss_10_percentage"
                                    className="form-control text-uppercase icueGenFormInput   bg-white text-muted"
                                    defaultValue="%"
                                  />
                                </div>
                                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                  <label
                                    htmlFor="icueGenFormTypeInsurance"
                                    className="form-label icueTextPrimary icueGenInfoLabel mt-3"
                                  >
                                    Class 12 Percentage
                                  </label>
                                  <input
                                    value={employeeData.class_12_percentage}
                                    onKeyDown={preventLeadingSpace}
                                    onChange={(e) =>
                                      handleInputChange(e, "employee")
                                    }
                                    type="text"
                                    id="icueGenFormTypeInsurance"
                                    name="class_12_percentage"
                                    className="form-control text-uppercase icueGenFormInput   bg-white text-muted"
                                    defaultValue="%"
                                  />
                                </div>
                                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                  <label
                                    htmlFor="icueGenFormAlreadyInsured"
                                    className="form-label icueTextPrimary icueGenInfoLabel mt-3"
                                  >
                                    Class 12 Stream
                                  </label>
                                  <select
                                    value={employeeData.class_12_stream}
                                    onChange={(e) =>
                                      handleInputChange(e, "employee")
                                    }
                                    id="icueGenFormAlreadyInsured"
                                    name="class_12_stream"
                                    className="form-select text-uppercase icueGenFormInput   bg-white icueGenFormSel text-muted"
                                  >
                                    <option value="Commerce">Commerce</option>
                                    <option value="Science">Science</option>
                                    <option value="Arts">Arts</option>
                                  </select>
                                </div>
                                <br />
                              </div>

                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                <label
                                  htmlFor="icueGenFormCueMember"
                                  className="form-label icueTextPrimary icueGenInfoLabel mt-3"
                                >
                                  Highest Qualification
                                </label>
                                <select
                                  value={employeeData.highest_qualification}
                                  onChange={(e) =>
                                    handleInputChange(e, "employee")
                                  }
                                  id="icueGenFormCueMember"
                                  name="highest_qualification"
                                  className="form-select  text-uppercase icueGenFormInput   bg-white icueGenFormSel text-muted"
                                >
                                  <option value="HighSchool">
                                    High School
                                  </option>
                                  <option value="Bachelors">Bachelors</option>
                                  <option value="Masters">Masters</option>
                                  <option value="PhD">PhD</option>
                                </select>
                              </div>
                              <div className="row">
                                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                  <label
                                    htmlFor="icueGenFormTypeInsurance"
                                    className="form-label icueTextPrimary icueGenInfoLabel mt-3 pb-3"
                                  >
                                    Upload Class 10 Marksheet
                                  </label>
                                  <div className="pt-2">
                                    {!employeeData.class_10_marksheet &&
                                    !isDisabled ? (
                                      // Check if the file is not set and the field is not disabled
                                      <div>
                                        <label>
                                          {photoLoad ? (
                                            <div className="Group">
                                              <span className="spinner-border spinner-border-lg"></span>
                                            </div>
                                          ) : (
                                            <img
                                              style={{ height: "190px" }}
                                              src={ImagePlaceholder}
                                              alt="placeholder"
                                            />
                                          )}
                                          <input
                                            type="file"
                                            className="d-none"
                                            name="class_10_marksheet"
                                            onKeyDown={preventLeadingSpace}
                                            onChange={(e) =>
                                              handleInputChange(e, "employee")
                                            }
                                          />
                                        </label>
                                        {errors.class_10_marksheet && (
                                          // Show error message if validation fails
                                          <p className="p-error">
                                            {errors.class_10_marksheet}
                                          </p>
                                        )}
                                      </div>
                                    ) : (
                                      <div className="row form-group">
                                        <div className="img-preview">
                                          <img
                                            src={
                                              employeeData.class_10_marksheet
                                            }
                                            alt="Class 10 Marksheet Preview"
                                            style={{ maxHeight: "190px" }}
                                          />
                                          {!isDisabled && (
                                            <img
                                              onClick={() =>
                                                deleteFile("class_10_marksheet")
                                              }
                                              className="clear"
                                              src={X}
                                              alt="clear-preview"
                                            />
                                          )}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                  <label
                                    htmlFor="icueGenFormTypeInsurance"
                                    className="form-label icueTextPrimary icueGenInfoLabel mt-3 pb-3"
                                  >
                                    Upload Class 12 Marksheet
                                  </label>

                                  <div className="pt-2">
                                    {!employeeData.class_12_marksheet &&
                                    !isDisabled ? (
                                      <div>
                                        <label>
                                          {photoLoad ? (
                                            <div className="Group">
                                              <span className="spinner-border spinner-border-lg"></span>
                                            </div>
                                          ) : (
                                            <img
                                              style={{ height: "190px" }}
                                              src={ImagePlaceholder}
                                              alt="placeholder"
                                            />
                                          )}
                                          <input
                                            type="file"
                                            className="d-none"
                                            name="class_12_marksheet"
                                            onKeyDown={preventLeadingSpace}
                                            onChange={(e) =>
                                              handleInputChange(e, "employee")
                                            }
                                          />
                                        </label>
                                        {errors.class_12_marksheet && (
                                          <p className="p-error">
                                            {errors.class_12_marksheet}
                                          </p>
                                        )}
                                      </div>
                                    ) : (
                                      <div className="row form-group">
                                        <div className="img-preview">
                                          <img
                                            src={
                                              employeeData.class_12_marksheet
                                            }
                                            alt="Class 10 Marksheet Preview"
                                            style={{ maxHeight: "190px" }}
                                          />
                                          {!isDisabled && (
                                            <img
                                              onClick={() =>
                                                deleteFile("class_12_marksheet")
                                              }
                                              className="clear"
                                              src={X}
                                              alt="clear-preview"
                                            />
                                          )}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                  <label
                                    htmlFor="icueGenFormTypeInsurance"
                                    className="form-label icueTextPrimary icueGenInfoLabel mt-3"
                                  >
                                    Upload Highest Qualification Marksheet
                                  </label>

                                  <div className="pt-2">
                                    {!employeeData.highest_qualification_marksheet &&
                                    !isDisabled ? (
                                      <div>
                                        <label>
                                          {photoLoad ? (
                                            <div className="Group">
                                              <span className="spinner-border spinner-border-lg"></span>
                                            </div>
                                          ) : (
                                            <img
                                              style={{ height: "190px" }}
                                              src={ImagePlaceholder}
                                              alt="placeholder"
                                            />
                                          )}
                                          <input
                                            type="file"
                                            className="d-none"
                                            name="highest_qualification_marksheet"
                                            onKeyDown={preventLeadingSpace}
                                            onChange={(e) =>
                                              handleInputChange(e, "employee")
                                            }
                                          />
                                        </label>
                                        {errors.class_10_marksheet && (
                                          <p className="p-error">
                                            {
                                              errors.highest_qualification_marksheet
                                            }
                                          </p>
                                        )}
                                      </div>
                                    ) : (
                                      <div className="row form-group">
                                        <div className="img-preview">
                                          <img
                                            src={
                                              employeeData.highest_qualification_marksheet
                                            }
                                            alt="Class 10 Marksheet Preview"
                                            style={{ maxHeight: "190px" }}
                                          />
                                          {!isDisabled && (
                                            <img
                                              onClick={() =>
                                                deleteFile(
                                                  "highest_qualification_marksheet"
                                                )
                                              }
                                              className="clear"
                                              src={X}
                                              alt="clear-preview"
                                            />
                                          )}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>

                              <div className="row">
                                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                  <label
                                    htmlFor="icueGenFormTypeInsurance"
                                    className="form-label icueTextPrimary icueGenInfoLabel mt-3"
                                  >
                                    Degree
                                  </label>
                                  <input
                                    // value={employeeData.dgree}
                                    onChange={(e) =>
                                      handleInputChange(e, "employee")
                                    }
                                    type="text"
                                    onKeyDown={preventLeadingSpace}
                                    id="icueGenFormTypeInsurance"
                                    name="dgree"
                                    className="form-control text-uppercase icueGenFormInput   bg-white text-muted"
                                  />
                                </div>
                                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                  <label
                                    htmlFor="icueGenFormTypeInsurance"
                                    className="form-label icueTextPrimary icueGenInfoLabel mt-3"
                                  >
                                    Institution/University Name
                                  </label>
                                  <input
                                    value={
                                      employeeData.institute_university_name
                                    }
                                    onKeyDown={preventLeadingSpace}
                                    onChange={(e) =>
                                      handleInputChange(e, "employee")
                                    }
                                    type="text"
                                    id="icueGenFormTypeInsurance"
                                    name="institute_university_name"
                                    className="form-control text-uppercase icueGenFormInput   bg-white text-muted"
                                    defaultValue=" "
                                  />
                                </div>
                                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                  <label
                                    htmlFor="icueGenFormTypeInsurance"
                                    className="form-label icueTextPrimary icueGenInfoLabel mt-3"
                                  >
                                    Year of Graduation
                                  </label>
                                  <input
                                    value={employeeData.year_of_graduation}
                                    onKeyDown={preventLeadingSpace}
                                    onChange={(e) =>
                                      handleInputChange(e, "employee")
                                    }
                                    type="text"
                                    id="icueGenFormTypeInsurance"
                                    name="year_of_graduation"
                                    className="form-control text-uppercase icueGenFormInput   bg-white text-muted"
                                    defaultValue=" "
                                  />
                                </div>{" "}
                                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                  <label
                                    htmlFor="icueGenFormTypeInsurance"
                                    className="form-label icueTextPrimary icueGenInfoLabel mt-3"
                                  >
                                    Additional Courses
                                  </label>
                                  <input
                                    value={employeeData.additional_courses}
                                    onKeyDown={preventLeadingSpace}
                                    onChange={(e) =>
                                      handleInputChange(e, "employee")
                                    }
                                    type="text"
                                    id="icueGenFormTypeInsurance"
                                    name="additional_courses"
                                    className="form-control text-uppercase icueGenFormInput   bg-white text-muted"
                                    defaultValue=" "
                                  />
                                </div>
                                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                  <label
                                    htmlFor="icueGenFormTypeInsurance"
                                    className="form-label icueTextPrimary icueGenInfoLabel mt-3"
                                  >
                                    Certification
                                  </label>

                                  <div className="pt-2">
                                    {!employeeData.certification_additional_courses &&
                                    !isDisabled ? (
                                      <div>
                                        <label>
                                          {photoLoad ? (
                                            <div className="Group">
                                              <span className="spinner-border spinner-border-lg"></span>
                                            </div>
                                          ) : (
                                            <img
                                              style={{ height: "190px" }}
                                              src={ImagePlaceholder}
                                              alt="placeholder"
                                            />
                                          )}
                                          <input
                                            type="file"
                                            onKeyDown={preventLeadingSpace}
                                            className="d-none"
                                            name="certification_additional_courses"
                                            onChange={(e) =>
                                              handleInputChange(
                                                e,

                                                "employee"
                                              )
                                            }
                                          />
                                        </label>
                                        {errors.certification_additional_courses && (
                                          <p className="p-error">
                                            {
                                              errors.certification_additional_courses
                                            }
                                          </p>
                                        )}
                                      </div>
                                    ) : (
                                      <div className="row form-group">
                                        <div className="img-preview">
                                          <img
                                            src={
                                              employeeData.certification_additional_courses
                                            }
                                            alt="certification_additional_courses"
                                            style={{ maxHeight: "190px" }}
                                          />
                                          {!isDisabled && (
                                            <img
                                              onClick={() =>
                                                deleteFile(
                                                  "certification_additional_courses"
                                                )
                                              }
                                              className="clear"
                                              src={X}
                                              alt="clear-preview"
                                            />
                                          )}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                  <label
                                    htmlFor="icueGenFormTypeInsurance"
                                    className="form-label icueTextPrimary icueGenInfoLabel mt-3"
                                  >
                                    Upload Degree
                                  </label>

                                  <div className="pt-2">
                                    {!employeeData.degree_upload &&
                                    !isDisabled ? (
                                      <div>
                                        <label>
                                          {photoLoad ? (
                                            <div className="Group">
                                              <span className="spinner-border spinner-border-lg"></span>
                                            </div>
                                          ) : (
                                            <img
                                              style={{ height: "190px" }}
                                              src={ImagePlaceholder}
                                              alt="placeholder"
                                            />
                                          )}
                                          <input
                                            type="file"
                                            className="d-none"
                                            name="degree_upload"
                                            onKeyDown={preventLeadingSpace}
                                            onChange={(e) =>
                                              handleInputChange(e, "employee")
                                            }
                                          />
                                        </label>
                                        {errors.degree_upload && (
                                          <p className="p-error">
                                            {errors.degree_upload}
                                          </p>
                                        )}
                                      </div>
                                    ) : (
                                      <div className="row form-group">
                                        <div className="img-preview">
                                          <img
                                            src={employeeData.degree_upload}
                                            alt="Class 10 Marksheet Preview"
                                            style={{ maxHeight: "190px" }}
                                          />
                                          {!isDisabled && (
                                            <img
                                              onClick={() =>
                                                deleteFile("degree_upload")
                                              }
                                              className="clear"
                                              src={X}
                                              alt="clear-preview"
                                            />
                                          )}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                  <label
                                    htmlFor="icueGenFormTypeInsurance"
                                    className="form-label icueTextPrimary icueGenInfoLabel mt-3"
                                  >
                                    Skills Acquired Certification
                                  </label>

                                  <div className="pt-2">
                                    {!employeeData.certification_skill_acquired &&
                                    !isDisabled ? (
                                      <div>
                                        <label>
                                          {photoLoad ? (
                                            <div className="Group">
                                              <span className="spinner-border spinner-border-lg"></span>
                                            </div>
                                          ) : (
                                            <img
                                              style={{ height: "190px" }}
                                              src={ImagePlaceholder}
                                              alt="placeholder"
                                            />
                                          )}
                                          <input
                                            type="file"
                                            className="d-none"
                                            onKeyDown={preventLeadingSpace}
                                            name="certification_skill_acquired"
                                            onChange={(e) =>
                                              handleInputChange(e, "employee")
                                            }
                                          />
                                        </label>
                                        {errors.certification_skill_acquired && (
                                          <p className="p-error">
                                            {
                                              errors.certification_skill_acquired
                                            }
                                          </p>
                                        )}
                                      </div>
                                    ) : (
                                      <div className="row form-group">
                                        <div className="img-preview">
                                          <img
                                            src={
                                              employeeData.certification_skill_acquired
                                            }
                                            alt="Class 10 Marksheet Preview"
                                            style={{ maxHeight: "190px" }}
                                          />
                                          {!isDisabled && (
                                            <img
                                              onClick={() =>
                                                deleteFile(
                                                  "certification_skill_acquired"
                                                )
                                              }
                                              className="clear"
                                              src={X}
                                              alt="clear-preview"
                                            />
                                          )}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                  <label
                                    htmlFor="icueGenFormTypeInsurance"
                                    className="form-label icueTextPrimary icueGenInfoLabel mt-3"
                                  >
                                    Skills Acquired
                                  </label>
                                  <input
                                    value={employeeData.skill_acquired}
                                    onChange={(e) =>
                                      handleInputChange(e, "employee")
                                    }
                                    type="text"
                                    onKeyDown={preventLeadingSpace}
                                    id="icueGenFormTypeInsurance"
                                    name="skill_acquired"
                                    className="form-control text-uppercase icueGenFormInput   bg-white text-muted"
                                    defaultValue=" "
                                  />
                                </div>
                              </div>
                            </div>{" "}
                            <hr></hr>{" "}
                          </div>
                        </div>

                        {/* <div
                          className="bg-white shadow p-4 pb-5 rounded-3"
                          style={{
                            marginTop: "4rem",
                            marginLeft: "0.8rem",
                            marginRight: "0.8rem",
                          }}
                        >
                          <div className="d-flex justify-content-between pb-4 border-bottom py-0 mb-3">
                            <div className="bg-white">
                              <h4
                                className="text-capitalize icueTextPrimary"
                                style={{ fontFamily: "ErasDemiITC" }}
                              >
                                Previous Employment Details
                              </h4>
                            </div>
                            <div className="bg-white"></div>
                          </div>

                          {companyData.map((item, index) => (
                            <div
                              key={index}
                              className="multisteps-form__content"
                              style={{ fontFamily: "Calibri" }}
                            >
                              <div className="row">
                                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                  <label
                                    htmlFor={`companyName-${index}`}
                                    className="form-label icueTextPrimary icueGennInfoLabel mt-3"
                                  >
                                    Company Name
                                  </label>
                                  <input
                                    type="text"
                                    id={`companyName-${index}`}
                                    name="company_name"
                                    className="form-control text-uppercase icueGennFormInput   bg-white text-muted"
                                    value={item.company_name}
                                    onKeyDown={preventLeadingSpace}
                                    onChange={(e) =>
                                      handleInputChangeCompany(e, "job", index)
                                    }
                                  />
                                </div>
                                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                  <label
                                    htmlFor={`jobTitle-${index}`}
                                    className="form-label icueTextPrimary icueGennInfoLabel mt-3"
                                  >
                                    Job Title
                                  </label>
                                  <input
                                    type="text"
                                    onKeyDown={preventLeadingSpace}
                                    id={`jobTitle-${index}`}
                                    name="job_title"
                                    className="form-control text-uppercase icueGennFormInput   bg-white text-muted"
                                    value={item.job_title}
                                    onChange={(e) =>
                                      handleInputChangeCompany(e, "job", index)
                                    }
                                  />
                                </div>
                                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                  <label
                                    htmlFor={`startDate-${index}`}
                                    className="form-label icueTextPrimary icueGennInfoLabel mt-3"
                                  >
                                    Start Date
                                  </label>
                                  <input
                                    type="date"
                                    onKeyDown={preventLeadingSpace}
                                    id={`startDate-${index}`}
                                    name="start_date"
                                    className="form-control text-uppercase icueGennFormInput bg-white text-muted"
                                    value={
                                      item.start_date
                                        ? new Date(item.start_date)
                                            .toISOString()
                                            .slice(0, 10)
                                        : ""
                                    }
                                    onChange={(e) =>
                                      handleInputChangeCompany(e, "job", index)
                                    }
                                  />
                                </div>

                                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                  <label
                                    htmlFor={`endDate-${index}`}
                                    className="form-label icueTextPrimary icueGennInfoLabel mt-3"
                                  >
                                    End Date
                                  </label>
                                  <input
                                    type="date"
                                    id={`endDate-${index}`}
                                    onKeyDown={preventLeadingSpace}
                                    name="end_date"
                                    className="form-control text-uppercase icueGennFormInput bg-white text-muted"
                                    value={
                                      item.end_date
                                        ? new Date(item.end_date)
                                            .toISOString()
                                            .slice(0, 10)
                                        : ""
                                    }
                                    onChange={(e) =>
                                      handleInputChangeCompany(e, "job", index)
                                    }
                                  />
                                </div>

                                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 pt-3">
                                  {!isDisabled && (
                                    <label
                                      htmlFor={`relieving_letter-${index}`}
                                    >
                                      Upload Relieving Letter
                                    </label>
                                  )}

                                  <div className="pt-2">
                                    {!item.relieving_letter && !isDisabled ? (
                                      <div>
                                        <label>
                                          {photoLoad ? (
                                            <div className="Group">
                                              <span className="spinner-border spinner-border-lg"></span>
                                            </div>
                                          ) : (
                                            <img
                                              style={{ height: "190px" }}
                                              src={ImagePlaceholder}
                                              alt="placeholder"
                                            />
                                          )}
                                          <input
                                            type="file"
                                            id={`relieving_letter-${index}`}
                                            onKeyDown={preventLeadingSpace}
                                            className="d-none"
                                            name="relieving_letter"
                                            disabled={
                                              !!photoFile.relieving_letter
                                            }
                                            onChange={(e) =>
                                              handleInputChangeCompany(
                                                e,
                                                "job",
                                                index
                                              )
                                            }
                                             
                                          />
                                        </label>
                                        {!photoFile.relieving_letter && (
                                          <p className="p-error">
                                            {errors.relieving_letter}
                                          </p>
                                        )}
                                      </div>
                                    ) : (
                                      <div className="row form-group">
                                        <div className="img-preview">
                                          <img
                                            src={item.relieving_letter}
                                            alt="Relieving Letter Preview"
                                            style={{ maxHeight: "190px" }}
                                          />
                                          {!isDisabled && (
                                            <img
                                              onClick={() =>
                                                deleteFile(
                                                  "relieving_letter",
                                                  index
                                                )
                                              }
                                              className="clear"
                                              src={X}
                                              alt="clear-preview"
                                            />
                                          )}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>

                                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12  pt-3">
                                  {!isDisabled && (
                                    <label
                                      htmlFor={`signed_resignation_letter-${index}`}
                                    >
                                      Upload resignation Letter
                                    </label>
                                  )}
                                  <div className="pt-2">
                                    {!item.signed_resignation_letter &&
                                    !isDisabled ? (
                                      <div>
                                        <label>
                                          {photoLoad ? (
                                            <div className="Group">
                                              <span className="spinner-border spinner-border-lg"></span>
                                            </div>
                                          ) : (
                                            <img
                                              style={{ height: "190px" }}
                                              src={ImagePlaceholder}
                                              alt="placeholder"
                                            />
                                          )}
                                          <input
                                            type="file"
                                            onKeyDown={preventLeadingSpace}
                                            id={`signed_resignation_letter-${index}`}
                                            className="d-none"
                                            name="signed_resignation_letter"
                                            disabled={
                                              !!photoFile.signed_resignation_letter
                                            }
                                            onChange={(e) =>
                                              handleInputChangeCompany(
                                                e,
                                                "job",
                                                index
                                              )
                                            }
                                          />
                                        </label>
                                        {!photoFile.signed_resignation_letter && (
                                          <p className="p-error">
                                            {errors.signed_resignation_letter}
                                          </p>
                                        )}
                                      </div>
                                    ) : (
                                      <div className="row form-group">
                                        <div className="img-preview">
                                          <img
                                            src={item.signed_resignation_letter}
                                            alt="Relieving Letter Preview"
                                            style={{ maxHeight: "190px" }}
                                          />
                                          {!isDisabled && (
                                            <img
                                              onClick={() =>
                                                deleteFile(
                                                  "signed_resignation_letter",
                                                  index
                                                )
                                              }
                                              className="clear"
                                              src={X}
                                              alt="clear-preview"
                                            />
                                          )}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>

                                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12  pt-3">
                                  {!isDisabled && (
                                    <label htmlFor={`pay_slip-${index}`}>
                                      Upload pay slip
                                    </label>
                                  )}
                                  <div>
                                    {!item.pay_slip && !isDisabled ? (
                                      <div className="pt-2">
                                        <label>
                                          {photoLoad ? (
                                            <div className="Group">
                                              <span className="spinner-border spinner-border-lg"></span>
                                            </div>
                                          ) : (
                                            <img
                                              style={{ height: "190px" }}
                                              src={ImagePlaceholder}
                                              alt="placeholder"
                                            />
                                          )}
                                          <input
                                            type="file"
                                            id={`pay_slip-${index}`}
                                            onKeyDown={preventLeadingSpace}
                                            className="d-none"
                                            name="pay_slip"
                                            
                                            disabled={!!photoFile.pay_slip}
                                            onChange={(e) =>
                                              handleInputChangeCompany(
                                                e,
                                                "job",
                                                index
                                              )
                                            }
                                          />
                                        </label>
                                        {!photoFile.pay_slip && (
                                          <p className="p-error">
                                            {errors.pay_slip}
                                          </p>
                                        )}
                                      </div>
                                    ) : (
                                      <div className="row form-group">
                                        <div className="img-preview">
                                          <img
                                            src={item.pay_slip}
                                            alt="Relieving Letter Preview"
                                            style={{ maxHeight: "190px" }}
                                          />
                                          {!isDisabled && (
                                            <img
                                              onClick={() =>
                                                deleteFile("pay_slip", index)
                                              }
                                              className="clear"
                                              src={X}
                                              alt="clear-preview"
                                            />
                                          )}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>

                                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12  pt-3">
                                  {!isDisabled && (
                                    <label htmlFor={`offerLetter-${index}`}>
                                      Upload Offer Letter
                                    </label>
                                  )}
                                  <div>
                                    {!item.offer_letter && !isDisabled ? (
                                      <div className="pt-2">
                                        <label>
                                          {photoLoad ? (
                                            <div className="Group">
                                              <span className="spinner-border spinner-border-lg"></span>
                                            </div>
                                          ) : (
                                            <img
                                              style={{ height: "190px" }}
                                              src={ImagePlaceholder}
                                              alt="placeholder"
                                            />
                                          )}
                                          <input
                                            type="file"
                                            onKeyDown={preventLeadingSpace}
                                            id={`offer_letter-${index}`}
                                            className="d-none"
                                            name="offer_letter"
                                            disabled={!!photoFile.offer_letter}
                                            onChange={(e) =>
                                              handleInputChangeCompany(
                                                e,
                                                "job",
                                                index
                                              )
                                            }
                                          />
                                        </label>
                                        {!photoFile.offer_letter && (
                                          <p className="p-error">
                                            {errors.offer_letter}
                                          </p>
                                        )}
                                      </div>
                                    ) : (
                                      <div className="row form-group">
                                        <div className="img-preview">
                                          <img
                                            src={item.offer_letter}
                                            alt="Relieving Letter Preview"
                                            style={{ maxHeight: "190px" }}
                                          />
                                          {!isDisabled && (
                                            <img
                                              onClick={() =>
                                                deleteFile(
                                                  "offer_letter",
                                                  index
                                                )
                                              }
                                              className="clear"
                                              src={X}
                                              alt="clear-preview"
                                            />
                                          )}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>

                              <hr />
                            </div>
                          ))}

                        
                          <button
                            type="button"
                            onClick={addJobSection}
                            style={{
                              marginTop: "20px",
                              marginLeft: "20px",
                              padding: "10px 20px",
                              backgroundColor: "#007bff",
                              color: "#fff",
                              border: "none",
                              borderRadius: "5px",
                              cursor: "pointer",
                            }}
                          >
                            Add More Company
                          </button>
                        </div> */}
                        <div
                          className="bg-white shadow p-4 pb-5 rounded-3"
                          style={{
                            marginTop: "4rem",
                            marginLeft: "0.8rem",
                            marginRight: "0.8rem",
                          }}
                        >
                          <div className="d-flex justify-content-between pb-4 border-bottom py-0 mb-3">
                            <div className="bg-white">
                              <h4
                                className="text-capitalize icueTextPrimary"
                                style={{ fontFamily: "ErasDemiITC" }}
                              >
                                Previous Employment Details
                              </h4>
                            </div>
                            <div className="bg-white"></div>
                          </div>

                          {companyData.map((item, index) => (
                            <div
                              key={index}
                              className="multisteps-form__content"
                              style={{
                                fontFamily: "Calibri",
                                position: "relative",
                              }} // Added relative positioning
                            >
                              {/* START: Added Delete Icon */}
                              {companyData.length > 1 && (
                                <FontAwesomeIcon
                                  icon={faTrash}
                                  type="button"
                                  onClick={() => removeCompanySection(index)}
                                  style={{
                                    position: "absolute",
                                    top: "10px",
                                    right: "10px",
                                    color: "red",
                                    cursor: "pointer",
                                    fontSize: "20px",
                                    zIndex: 1,
                                  }}
                                />
                              )}
                              {/* END: Added Delete Icon */}

                              <div className="row">
                                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                  <label
                                    htmlFor={`companyName-${index}`}
                                    className="form-label icueTextPrimary icueGennInfoLabel mt-3"
                                  >
                                    Company Name
                                  </label>
                                  <input
                                    type="text"
                                    id={`companyName-${index}`}
                                    name="company_name"
                                    className="form-control text-uppercase icueGennFormInput   bg-white text-muted"
                                    value={item.company_name}
                                    onKeyDown={preventLeadingSpace}
                                    onChange={(e) =>
                                      handleInputChangeCompany(e, "job", index)
                                    }
                                  />
                                </div>
                                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                  <label
                                    htmlFor={`jobTitle-${index}`}
                                    className="form-label icueTextPrimary icueGennInfoLabel mt-3"
                                  >
                                    Job Title
                                  </label>
                                  <input
                                    type="text"
                                    onKeyDown={preventLeadingSpace}
                                    id={`jobTitle-${index}`}
                                    name="job_title"
                                    className="form-control text-uppercase icueGennFormInput   bg-white text-muted"
                                    value={item.job_title}
                                    onChange={(e) =>
                                      handleInputChangeCompany(e, "job", index)
                                    }
                                  />
                                </div>
                                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                  <label
                                    htmlFor={`startDate-${index}`}
                                    className="form-label icueTextPrimary icueGennInfoLabel mt-3"
                                  >
                                    Start Date
                                  </label>
                                  <input
                                    type="date"
                                    onKeyDown={preventLeadingSpace}
                                    id={`startDate-${index}`}
                                    name="start_date"
                                    className="form-control text-uppercase icueGennFormInput bg-white text-muted"
                                    value={
                                      item.start_date
                                        ? new Date(item.start_date)
                                            .toISOString()
                                            .slice(0, 10)
                                        : ""
                                    }
                                    onChange={(e) =>
                                      handleInputChangeCompany(e, "job", index)
                                    }
                                  />
                                </div>

                                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                  <label
                                    htmlFor={`endDate-${index}`}
                                    className="form-label icueTextPrimary icueGennInfoLabel mt-3"
                                  >
                                    End Date
                                  </label>
                                  <input
                                    type="date"
                                    id={`endDate-${index}`}
                                    onKeyDown={preventLeadingSpace}
                                    name="end_date"
                                    className="form-control text-uppercase icueGennFormInput bg-white text-muted"
                                    value={
                                      item.end_date
                                        ? new Date(item.end_date)
                                            .toISOString()
                                            .slice(0, 10)
                                        : ""
                                    }
                                    onChange={(e) =>
                                      handleInputChangeCompany(e, "job", index)
                                    }
                                  />
                                </div>

                                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 pt-3">
                                  {!isDisabled && (
                                    <label
                                      htmlFor={`relieving_letter-${index}`}
                                    >
                                      Upload Relieving Letter
                                    </label>
                                  )}

                                  <div className="pt-2">
                                    {!item.relieving_letter && !isDisabled ? (
                                      <div>
                                        <label>
                                          {photoLoad ? (
                                            <div className="Group">
                                              <span className="spinner-border spinner-border-lg"></span>
                                            </div>
                                          ) : (
                                            <img
                                              style={{ height: "190px" }}
                                              src={ImagePlaceholder}
                                              alt="placeholder"
                                            />
                                          )}
                                          <input
                                            type="file"
                                            id={`relieving_letter-${index}`}
                                            onKeyDown={preventLeadingSpace}
                                            className="d-none"
                                            name="relieving_letter"
                                            disabled={
                                              !!photoFile.relieving_letter
                                            }
                                            onChange={(e) =>
                                              handleInputChangeCompany(
                                                e,
                                                "job",
                                                index
                                              )
                                            }
                                          />
                                        </label>
                                        {!photoFile.relieving_letter && (
                                          <p className="p-error">
                                            {errors.relieving_letter}
                                          </p>
                                        )}
                                      </div>
                                    ) : (
                                      <div className="row form-group">
                                        <div className="img-preview">
                                          <img
                                            src={item.relieving_letter}
                                            alt="Relieving Letter Preview"
                                            style={{ maxHeight: "190px" }}
                                          />
                                          {!isDisabled && (
                                            <img
                                              onClick={() =>
                                                deleteFile(
                                                  "relieving_letter",
                                                  index
                                                )
                                              }
                                              className="clear"
                                              src={X}
                                              alt="clear-preview"
                                            />
                                          )}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>

                                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12  pt-3">
                                  {!isDisabled && (
                                    <label
                                      htmlFor={`signed_resignation_letter-${index}`}
                                    >
                                      Upload resignation Letter
                                    </label>
                                  )}
                                  <div className="pt-2">
                                    {!item.signed_resignation_letter &&
                                    !isDisabled ? (
                                      <div>
                                        <label>
                                          {photoLoad ? (
                                            <div className="Group">
                                              <span className="spinner-border spinner-border-lg"></span>
                                            </div>
                                          ) : (
                                            <img
                                              style={{ height: "190px" }}
                                              src={ImagePlaceholder}
                                              alt="placeholder"
                                            />
                                          )}
                                          <input
                                            type="file"
                                            onKeyDown={preventLeadingSpace}
                                            id={`signed_resignation_letter-${index}`}
                                            className="d-none"
                                            name="signed_resignation_letter"
                                            disabled={
                                              !!photoFile.signed_resignation_letter
                                            }
                                            onChange={(e) =>
                                              handleInputChangeCompany(
                                                e,
                                                "job",
                                                index
                                              )
                                            }
                                          />
                                        </label>
                                        {!photoFile.signed_resignation_letter && (
                                          <p className="p-error">
                                            {errors.signed_resignation_letter}
                                          </p>
                                        )}
                                      </div>
                                    ) : (
                                      <div className="row form-group">
                                        <div className="img-preview">
                                          <img
                                            src={item.signed_resignation_letter}
                                            alt="Relieving Letter Preview"
                                            style={{ maxHeight: "190px" }}
                                          />
                                          {!isDisabled && (
                                            <img
                                              onClick={() =>
                                                deleteFile(
                                                  "signed_resignation_letter",
                                                  index
                                                )
                                              }
                                              className="clear"
                                              src={X}
                                              alt="clear-preview"
                                            />
                                          )}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>

                                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12  pt-3">
                                  {!isDisabled && (
                                    <label htmlFor={`pay_slip-${index}`}>
                                      Upload pay slip
                                    </label>
                                  )}
                                  <div>
                                    {!item.pay_slip && !isDisabled ? (
                                      <div className="pt-2">
                                        <label>
                                          {photoLoad ? (
                                            <div className="Group">
                                              <span className="spinner-border spinner-border-lg"></span>
                                            </div>
                                          ) : (
                                            <img
                                              style={{ height: "190px" }}
                                              src={ImagePlaceholder}
                                              alt="placeholder"
                                            />
                                          )}
                                          <input
                                            type="file"
                                            id={`pay_slip-${index}`}
                                            onKeyDown={preventLeadingSpace}
                                            className="d-none"
                                            name="pay_slip"
                                            disabled={!!photoFile.pay_slip}
                                            onChange={(e) =>
                                              handleInputChangeCompany(
                                                e,
                                                "job",
                                                index
                                              )
                                            }
                                          />
                                        </label>
                                        {!photoFile.pay_slip && (
                                          <p className="p-error">
                                            {errors.pay_slip}
                                          </p>
                                        )}
                                      </div>
                                    ) : (
                                      <div className="row form-group">
                                        <div className="img-preview">
                                          <img
                                            src={item.pay_slip}
                                            alt="Relieving Letter Preview"
                                            style={{ maxHeight: "190px" }}
                                          />
                                          {!isDisabled && (
                                            <img
                                              onClick={() =>
                                                deleteFile("pay_slip", index)
                                              }
                                              className="clear"
                                              src={X}
                                              alt="clear-preview"
                                            />
                                          )}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>

                                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12  pt-3">
                                  {!isDisabled && (
                                    <label htmlFor={`offerLetter-${index}`}>
                                      Upload Offer Letter
                                    </label>
                                  )}
                                  <div>
                                    {!item.offer_letter && !isDisabled ? (
                                      <div className="pt-2">
                                        <label>
                                          {photoLoad ? (
                                            <div className="Group">
                                              <span className="spinner-border spinner-border-lg"></span>
                                            </div>
                                          ) : (
                                            <img
                                              style={{ height: "190px" }}
                                              src={ImagePlaceholder}
                                              alt="placeholder"
                                            />
                                          )}
                                          <input
                                            type="file"
                                            onKeyDown={preventLeadingSpace}
                                            id={`offer_letter-${index}`}
                                            className="d-none"
                                            name="offer_letter"
                                            disabled={!!photoFile.offer_letter}
                                            onChange={(e) =>
                                              handleInputChangeCompany(
                                                e,
                                                "job",
                                                index
                                              )
                                            }
                                          />
                                        </label>
                                        {!photoFile.offer_letter && (
                                          <p className="p-error">
                                            {errors.offer_letter}
                                          </p>
                                        )}
                                      </div>
                                    ) : (
                                      <div className="row form-group">
                                        <div className="img-preview">
                                          <img
                                            src={item.offer_letter}
                                            alt="Relieving Letter Preview"
                                            style={{ maxHeight: "190px" }}
                                          />
                                          {!isDisabled && (
                                            <img
                                              onClick={() =>
                                                deleteFile(
                                                  "offer_letter",
                                                  index
                                                )
                                              }
                                              className="clear"
                                              src={X}
                                              alt="clear-preview"
                                            />
                                          )}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                              <hr />
                            </div>
                          ))}

                          {/* Add More Company Button */}
                          <button
                            type="button"
                            onClick={addJobSection}
                            style={{
                              marginTop: "20px",
                              marginLeft: "20px",
                              padding: "10px 20px",
                              backgroundColor: "#007bff",
                              color: "#fff",
                              border: "none",
                              borderRadius: "5px",
                              cursor: "pointer",
                            }}
                          >
                            Add More Company
                          </button>
                        </div>
                        <div
                          className="bg-white shadow p-4 pb-5 rounded-3"
                          style={{
                            marginTop: "4rem",
                            marginLeft: "0.8rem",
                            marginRight: "0.8rem",
                          }}
                        >
                          <div className="d-flex justify-content-between pb-4 border-bottom py-0 mb-3">
                            <div className="bg-white">
                              <h4
                                className="text-capitalize icueTextPrimary"
                                style={{ fontFamily: "ErasDemiITC" }}
                              >
                                Employment Details
                              </h4>
                            </div>
                            <div className="bg-white"></div>
                          </div>
                          <div
                            className="multisteps-form__content"
                            style={{ fontFamily: "Calibri" }}
                          >
                            <div className="row">
                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                <label
                                  htmlFor="icueEmpFormTypeInsured"
                                  className="form-label icueTextPrimary icueEmpInfoLabel mt-3"
                                >
                                  Employee ID
                                </label>
                                <input
                                  value={employeeData.employee_id}
                                  onChange={(e) =>
                                    handleInputChange(e, "employee")
                                  }
                                  onKeyDown={preventLeadingSpace}
                                  type="text"
                                  id="icueEmpFormTypeInsured"
                                  name="employee_id"
                                  className="form-control text-uppercase icueEmpFormInput   bg-white text-muted"
                                  defaultValue="55555"
                                />

                                {errors.employee_id && (
                                  <p className="p-error">
                                    {errors.employee_id}
                                  </p>
                                )}
                              </div>
                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                <label
                                  htmlFor="icueEmpFormTypeInsurance"
                                  className="form-label icueTextPrimary icueEmpInfoLabel mt-3"
                                >
                                  Position
                                </label>
                                <Form.Select
                                  name="joining_position"
                                  value={employeeData.joining_position}
                                  onChange={(e) =>
                                    handleInputChange(e, "employee")
                                  }
                                >
                                  <option value="" disabled>
                                    Select Designation
                                  </option>
                                  {role.map((role) => (
                                    <option
                                      key={role.role_id}
                                      value={role.role_name}
                                    >
                                      {role.role_name}
                                    </option>
                                  ))}
                                </Form.Select>
                              </div>
                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                <label
                                  htmlFor="icueEmpFormTypeInsurance"
                                  className="form-label icueTextPrimary icueEmpInfoLabel mt-3"
                                >
                                  Department
                                </label>

                                <Form.Select
                                  name="department"
                                  value={employeeData.department}
                                  onChange={(e) =>
                                    handleInputChange(e, "employee")
                                  }
                                >
                                  <option value="" disabled>
                                    Select Department
                                  </option>
                                  {department.map((dept) => (
                                    <option
                                      key={dept.department_id}
                                      value={dept.department_name}
                                    >
                                      {dept.department_name}
                                    </option>
                                  ))}
                                </Form.Select>
                              </div>
                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                <label
                                  htmlFor="icueEmpFormTypeInsurance"
                                  className="form-label icueTextPrimary icueEmpInfoLabel mt-3"
                                >
                                  Select Manager
                                </label>

                                <Form.Select
                                  name="manager"
                                  value={employeeData.reporting_manager}
                                  onChange={(e) =>
                                    handleInputChange(e, "employee")
                                  }
                                >
                                  <option value="" disabled>
                                    Select Manager
                                  </option>
                                  {manager.map((item) => (
                                    <option
                                      key={item.employee_id}
                                      value={item.manager_name}
                                    >
                                      {item.manager_name}
                                    </option>
                                  ))}
                                </Form.Select>
                              </div>

                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                <label
                                  htmlFor="icueEmpFormTypeInsurance"
                                  className="form-label icueTextPrimary icueEmpInfoLabel mt-3"
                                >
                                  Joining Date
                                </label>
                                <input
                                  value={
                                    employeeData.joining_date
                                      ? new Date(employeeData.joining_date)
                                          .toISOString()
                                          .slice(0, 10)
                                      : ""
                                  }
                                  onKeyDown={preventLeadingSpace}
                                  onChange={(e) =>
                                    handleInputChange(e, "employee")
                                  }
                                  type="date"
                                  id="icueEmpFormTypeInsurance"
                                  name="joining_date"
                                  className="form-control text-uppercase icueEmpFormInput   bg-white text-muted"
                                  //
                                  defaultValue=""
                                />
                              </div>
                              {/* <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                <label
                                  htmlFor="icueEmpFormTypeInsurance"
                                  className="form-label icueTextPrimary icueEmpInfoLabel mt-3"
                                >
                                  Work Location
                                </label>
                                <input
                                  value={employeeData.work_location}
                                  onKeyDown={preventLeadingSpace}
                                  onChange={(e) =>
                                    handleInputChange(e, "employee")
                                  }
                                  type="text"
                                  id="icueEmpFormTypeInsurance"
                                  name="work_location"
                                  className="form-control text-uppercase icueEmpFormInput   bg-white text-muted"
                                  defaultValue="INdia"
                                />
                              </div> */}
                              {/* START: Replace the original "Work Location" div with this one */}
                              <div
                                className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12"
                                style={{ position: "relative" }}
                              >
                                <label
                                  htmlFor="work_location_input"
                                  className="form-label icueTextPrimary icueEmpInfoLabel mt-3"
                                >
                                  Work Location
                                </label>
                                <input
                                  id="work_location_input"
                                  value={employeeData.work_location}
                                  onKeyDown={preventLeadingSpace}
                                  onChange={handleWorkLocationChange}
                                  onFocus={() =>
                                    setShowWorkLocationDropdown(true)
                                  }
                                  onBlur={() => {
                                    setTimeout(() => {
                                      setShowWorkLocationDropdown(false);
                                    }, 150);
                                  }}
                                  type="text"
                                  name="work_location"
                                  className="form-control text-uppercase icueEmpFormInput bg-white text-muted"
                                  placeholder="Type to search locations..."
                                  autoComplete="off"
                                />
                                {showWorkLocationDropdown && (
                                  <ul
                                    style={{
                                      position: "absolute",
                                      top: "100%",
                                      left: "12px",
                                      right: "12px",
                                      backgroundColor: "white",
                                      border: "1px solid #ced4da",
                                      borderRadius: "0.25rem",
                                      maxHeight: "200px",
                                      overflowY: "auto",
                                      listStyleType: "none",
                                      padding: 0,
                                      margin: 0,
                                      zIndex: 1000,
                                    }}
                                  >
                                    {filteredWorkLocations.length > 0 ? (
                                      filteredWorkLocations.map(
                                        (location, index) => (
                                          <li
                                            key={index}
                                            onClick={() =>
                                              handleWorkLocationSelect(location)
                                            }
                                            style={{
                                              padding: "8px 12px",
                                              cursor: "pointer",
                                              textTransform: "capitalize",
                                            }}
                                            onMouseEnter={(e) =>
                                              (e.target.style.backgroundColor =
                                                "#f8f9fa")
                                            }
                                            onMouseLeave={(e) =>
                                              (e.target.style.backgroundColor =
                                                "white")
                                            }
                                          >
                                            {location}
                                          </li>
                                        )
                                      )
                                    ) : (
                                      <li
                                        style={{
                                          padding: "8px 12px",
                                          color: "#6c757d",
                                          cursor: "default",
                                        }}
                                      >
                                        No locations found
                                      </li>
                                    )}
                                  </ul>
                                )}
                              </div>

                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                <label
                                  htmlFor="icueEmpFormAlreadyInsured"
                                  className="form-label icueTextPrimary icueEmpInfoLabel mt-3"
                                >
                                  Employment Type
                                </label>
                                <select
                                  value={employeeData.employee_type}
                                  onChange={(e) =>
                                    handleInputChange(e, "employee")
                                  }
                                  id="icueEmpFormAlreadyInsured"
                                  name="employee_type"
                                  className="form-select text-uppercase icueEmpFormInput   bg-white icueEmpFormSel text-muted"
                                >
                                  <option value="FullTimeEmployee">
                                    Full Time Employee
                                  </option>
                                  <option value="Trainee">Trainee</option>
                                  <option value="Internship">Internship</option>
                                </select>
                              </div>
                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                <label
                                  htmlFor="icueEmpFormTypeInsurance"
                                  className="form-label icueTextPrimary icueEmpInfoLabel mt-3"
                                >
                                  Shift Time
                                </label>
                                <select
                                  value={employeeData.shift_timing}
                                  onChange={(e) =>
                                    handleInputChange(e, "employee")
                                  }
                                  id="icueEmpFormAlreadyInsured"
                                  name="shift_timing"
                                  className="form-select text-uppercase icueEmpFormInput   bg-white icueEmpFormSel text-muted"
                                >
                                  <option value="morning">Morning</option>
                                  <option value="evening">Evening</option>
                                  <option value="night">Night</option>
                                </select>
                              </div>
                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                <label
                                  htmlFor="icueEmpFormTypeInsurance"
                                  className="form-label icueTextPrimary icueEmpInfoLabel mt-3"
                                >
                                  Basic Salary
                                </label>
                                <input
                                  value={employeeData.basic_salary}
                                  onKeyDown={preventLeadingSpace}
                                  onChange={(e) =>
                                    handleInputChange(e, "employee")
                                  }
                                  type="number"
                                  id="icueEmpFormTypeInsurance"
                                  name="basic_salary"
                                  className="form-control text-uppercase icueEmpFormInput   bg-white text-muted"
                                  defaultValue=""
                                />
                              </div>
                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                <label
                                  htmlFor="icueEmpFormTypeInsurance"
                                  className="form-label icueTextPrimary icueEmpInfoLabel mt-3"
                                >
                                  HRA
                                </label>
                                <input
                                  value={employeeData.hra}
                                  onKeyDown={preventLeadingSpace}
                                  onChange={(e) =>
                                    handleInputChange(e, "employee")
                                  }
                                  type="number"
                                  id="icueEmpFormTypeInsurance"
                                  name="hra "
                                  className="form-control text-uppercase icueEmpFormInput   bg-white text-muted"
                                  defaultValue=""
                                />
                              </div>
                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                <label
                                  htmlFor="icueEmpFormTypeInsurance"
                                  className="form-label icueTextPrimary icueEmpInfoLabel mt-3"
                                >
                                  Conveyance
                                </label>
                                <input
                                  value={employeeData.conveyance}
                                  onKeyDown={preventLeadingSpace}
                                  onChange={(e) =>
                                    handleInputChange(e, "employee")
                                  }
                                  type="number"
                                  id="icueEmpFormTypeInsurance"
                                  name="conveyance"
                                  className="form-control text-uppercase icueEmpFormInput   bg-white text-muted"
                                  defaultValue=""
                                />
                              </div>
                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                <label
                                  htmlFor="icueEmpFormTypeInsurance"
                                  className="form-label icueTextPrimary icueEmpInfoLabel mt-3"
                                >
                                  Special Allowance
                                </label>
                                <input
                                  value={employeeData.special_allowance}
                                  onKeyDown={preventLeadingSpace}
                                  onChange={(e) =>
                                    handleInputChange(e, "employee")
                                  }
                                  type="number"
                                  id="icueEmpFormTypeInsurance"
                                  name="special_allowance"
                                  className="form-control text-uppercase icueEmpFormInput   bg-white text-muted"
                                  defaultValue=""
                                />
                              </div>
                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                <label
                                  htmlFor="icueEmpFormTypeInsurance"
                                  className="form-label icueTextPrimary icueEmpInfoLabel mt-3"
                                >
                                  Gross Salary
                                </label>
                                <input
                                  value={employeeData.gross_salary}
                                  onKeyDown={preventLeadingSpace}
                                  onChange={(e) =>
                                    handleInputChange(e, "employee")
                                  }
                                  type="number"
                                  id="icueEmpFormTypeInsurance"
                                  name="gross_salary"
                                  className="form-control text-uppercase icueEmpFormInput   bg-white text-muted"
                                  defaultValue=""
                                />
                              </div>
                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                <label
                                  htmlFor="icueEmpFormTypeInsurance"
                                  className="form-label icueTextPrimary icueEmpInfoLabel mt-3"
                                >
                                  Provident Fund
                                </label>
                                <input
                                  value={employeeData.provident_fund}
                                  onKeyDown={preventLeadingSpace}
                                  onChange={(e) =>
                                    handleInputChange(e, "employee")
                                  }
                                  type="number"
                                  id="icueEmpFormTypeInsurance"
                                  name="provident_fund"
                                  className="form-control text-uppercase icueEmpFormInput   bg-white text-muted"
                                  defaultValue=""
                                />
                              </div>
                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                <label
                                  htmlFor="icueEmpFormTypeInsurance"
                                  className="form-label icueTextPrimary icueEmpInfoLabel mt-3"
                                >
                                  ESI
                                </label>
                                <input
                                  value={employeeData.ESI}
                                  onKeyDown={preventLeadingSpace}
                                  onChange={(e) =>
                                    handleInputChange(e, "employee")
                                  }
                                  type="number"
                                  id="icueEmpFormTypeInsurance"
                                  name="ESI"
                                  className="form-control text-uppercase icueEmpFormInput   bg-white text-muted"
                                  defaultValue=""
                                />
                              </div>

                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                <label
                                  htmlFor="icueEmpFormTypeInsurance"
                                  className="form-label icueTextPrimary icueEmpInfoLabel mt-3"
                                >
                                  Total CTC{" "}
                                </label>
                                <input
                                  value={employeeData.inhand_salary}
                                  onKeyDown={preventLeadingSpace}
                                  onChange={(e) =>
                                    handleInputChange(e, "employee")
                                  }
                                  type="number"
                                  id="icueEmpFormTypeInsurance"
                                  name="inhand_salary"
                                  className="form-control text-uppercase icueEmpFormInput   bg-white text-muted"
                                  defaultValue=""
                                />
                              </div>
                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                <label
                                  htmlFor="icueEmpFormTypeInsurance"
                                  className="form-label icueTextPrimary icueEmpInfoLabel mt-3"
                                >
                                  Refrence 1
                                </label>
                                <input
                                  value={employeeData.reference1}
                                  onKeyDown={preventLeadingSpace}
                                  onChange={(e) =>
                                    handleInputChange(e, "employee")
                                  }
                                  type="text"
                                  id="icueEmpFormTypeInsurance"
                                  name="reference1"
                                  className="form-control text-uppercase icueEmpFormInput   bg-white text-muted"
                                  defaultValue=""
                                />
                              </div>
                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                <label
                                  htmlFor="icueEmpFormTypeInsurance"
                                  className="form-label icueTextPrimary icueEmpInfoLabel mt-3"
                                >
                                  Refrence 2
                                </label>
                                <input
                                  value={employeeData.reference2}
                                  onKeyDown={preventLeadingSpace}
                                  onChange={(e) =>
                                    handleInputChange(e, "employee")
                                  }
                                  type="text"
                                  id="icueEmpFormTypeInsurance"
                                  name="reference2"
                                  className="form-control text-uppercase icueEmpFormInput   bg-white text-muted"
                                  defaultValue=""
                                />
                              </div>
                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                <label
                                  htmlFor="icueDocFormTypeInsurance"
                                  className="form-label icueTextPrimary icueDocInfoLabel mt-3"
                                >
                                  Upload Policicue Offer Letter
                                </label>

                                <div className="pt-2">
                                  {!employeeData.policicue_offer_letter &&
                                  !isDisabled ? (
                                    // Check if the file is not set and the field is not disabled
                                    <div>
                                      <label>
                                        {photoLoad ? (
                                          <div className="Group">
                                            <span className="spinner-border spinner-border-lg"></span>
                                          </div>
                                        ) : (
                                          <img
                                            style={{ height: "190px" }}
                                            src={ImagePlaceholder}
                                            alt="placeholder"
                                          />
                                        )}
                                        <input
                                          type="file"
                                          className="d-none"
                                          onKeyDown={preventLeadingSpace}
                                          name="policicue_offer_letter"
                                          onChange={(e) =>
                                            handleInputChange(e, "employee")
                                          }
                                        />
                                      </label>
                                      {errors.policicue_offer_letter && (
                                        // Show error message if validation fails
                                        <p className="p-error">
                                          {errors.policicue_offer_letter}
                                        </p>
                                      )}
                                    </div>
                                  ) : (
                                    <div className="row form-group">
                                      <div className="img-preview">
                                        <img
                                          src={
                                            employeeData.policicue_offer_letter
                                          }
                                          alt="Class 10 Marksheet Preview"
                                          style={{ maxHeight: "190px" }}
                                        />
                                        {!isDisabled && (
                                          <img
                                            onClick={() =>
                                              deleteFile(
                                                "policicue_offer_letter"
                                              )
                                            }
                                            className="clear"
                                            src={X}
                                            alt="clear-preview"
                                          />
                                        )}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                            <hr></hr>
                          </div>
                        </div>

                        <div
                          className="bg-white shadow p-4 pb-5 rounded-3"
                          style={{
                            marginTop: "4rem",
                            marginLeft: "0.8rem",
                            marginRight: "0.8rem",
                          }}
                        >
                          <div className="d-flex justify-content-between pb-4 border-bottom py-0 mb-3">
                            <div className="bg-white">
                              <h4
                                className="text-capitalize icueTextPrimary"
                                style={{ fontFamily: "ErasDemiITC" }}
                              >
                                Document Verification
                              </h4>
                            </div>
                            <div className="bg-white"></div>
                          </div>
                          <div
                            className="multisteps-form__content"
                            style={{ fontFamily: "Calibri" }}
                          >
                            <div className="row">
                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                <label
                                  htmlFor="icueDocFormTypeInsurance"
                                  className="form-label icueTextPrimary icueDocInfoLabel mt-3"
                                >
                                  Upload Aadhar Card
                                </label>

                                <div>
                                  {!employeeData.adhar && !isDisabled ? (
                                    // Check if the file is not set and the field is not disabled
                                    <div className="pt-2">
                                      <label>
                                        {photoLoad ? (
                                          <div className="Group">
                                            <span className="spinner-border spinner-border-lg"></span>
                                          </div>
                                        ) : (
                                          <img
                                            style={{ height: "190px" }}
                                            src={ImagePlaceholder}
                                            alt="placeholder"
                                          />
                                        )}
                                        <input
                                          type="file"
                                          className="d-none"
                                          name="adhar"
                                          onChange={(e) =>
                                            handleInputChange(e, "employee")
                                          }
                                        />
                                      </label>
                                      {errors.adhar && (
                                        // Show error message if validation fails
                                        <p className="p-error">
                                          {errors.adhar}
                                        </p>
                                      )}
                                    </div>
                                  ) : (
                                    <div className="row form-group">
                                      <div className="img-preview">
                                        <img
                                          src={employeeData.adhar}
                                          alt="Class 10 Marksheet Preview"
                                          style={{ maxHeight: "190px" }}
                                        />
                                        {!isDisabled && (
                                          <img
                                            onClick={() => deleteFile("adhar")}
                                            className="clear"
                                            src={X}
                                            alt="clear-preview"
                                          />
                                        )}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                <label
                                  htmlFor="icueDocFormTypeInsurance"
                                  className="form-label icueTextPrimary icueDocInfoLabel mt-3"
                                >
                                  Upload PAN Card
                                </label>

                                <div>
                                  {!employeeData.pan && !isDisabled ? (
                                    // Check if the file is not set and the field is not disabled
                                    <div className="pt-2">
                                      <label>
                                        {photoLoad ? (
                                          <div className="Group">
                                            <span className="spinner-border spinner-border-lg"></span>
                                          </div>
                                        ) : (
                                          <img
                                            style={{ height: "190px" }}
                                            src={ImagePlaceholder}
                                            alt="placeholder"
                                          />
                                        )}
                                        <input
                                          type="file"
                                          className="d-none"
                                          name="pan"
                                          onChange={(e) =>
                                            handleInputChange(e, "employee")
                                          }
                                        />
                                      </label>
                                      {errors.pan && (
                                        // Show error message if validation fails
                                        <p className="p-error">{errors.pan}</p>
                                      )}
                                    </div>
                                  ) : (
                                    <div className="row form-group">
                                      <div className="img-preview">
                                        <img
                                          src={employeeData.pan}
                                          alt="Class 10 Marksheet Preview"
                                          style={{ maxHeight: "190px" }}
                                        />
                                        {!isDisabled && (
                                          <img
                                            onClick={() => deleteFile("pan")}
                                            className="clear"
                                            src={X}
                                            alt="clear-preview"
                                          />
                                        )}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                <label
                                  htmlFor="icueDocFormTypeInsurance"
                                  className="form-label icueTextPrimary icueDocInfoLabel mt-3"
                                >
                                  Upload Passport
                                </label>

                                <div className="pt-2">
                                  {!employeeData.passport && !isDisabled ? (
                                    // Check if the file is not set and the field is not disabled
                                    <div>
                                      <label>
                                        {photoLoad ? (
                                          <div className="Group">
                                            <span className="spinner-border spinner-border-lg"></span>
                                          </div>
                                        ) : (
                                          <img
                                            style={{ height: "190px" }}
                                            src={ImagePlaceholder}
                                            alt="placeholder"
                                          />
                                        )}
                                        <input
                                          type="file"
                                          className="d-none"
                                          name="passport"
                                          onChange={(e) =>
                                            handleInputChange(e, "employee")
                                          }
                                        />
                                      </label>
                                      {errors.passport && (
                                        // Show error message if validation fails
                                        <p className="p-error">
                                          {errors.passport}
                                        </p>
                                      )}
                                    </div>
                                  ) : (
                                    <div className="row form-group">
                                      <div className="img-preview">
                                        <img
                                          src={employeeData.passport}
                                          alt="Class 10 Marksheet Preview"
                                          style={{ maxHeight: "190px" }}
                                        />
                                        {!isDisabled && (
                                          <img
                                            onClick={() =>
                                              deleteFile("passport")
                                            }
                                            className="clear"
                                            src={X}
                                            alt="clear-preview"
                                          />
                                        )}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                            <hr></hr>
                          </div>
                          <button
                            className="signup-btn"
                            style={{
                              backgroundColor: "#007bff",
                              width: "270px",
                              height: "50px",
                              border: "none",
                              borderRadius: "5px",
                              marginRight: "30px",
                              color: "#fff",
                              fontWeight: "normal",
                              // margin: " 20px 0",
                              fontFamily: "ERASDEMIITC",
                              fontSize: "1rem",
                            }}
                            type="button"
                            onClick={handleSubmit}
                          >
                            Add Employee
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}
